$(document).ready(function () { 

    if ($(".album").length === 0)
        return;

    //mobilewarn

    mobileWarn();


    //filestack

    // filestackCallback = alFileAdd;
    // $(".albumFooterImagesDropCon,.albumFooterOptUploadBtn,.albumDropBoxCon").click(function () {
    //     filestackShow();
    // });

    // $("body").on("click",".filestakQueryLocal",function () {
    //     $("#albumFooterImagesDropFile").get(0).click();
    //     $(".filestakQuery").hide();
    // });

    // $("body").on("click",".filestakQueryCloud",function () {
    //     $(".filestakQuery").hide();
    //     filestackClient.picker(filestackPickerOption).open();
    // });

    // $("body").on("click",".filestakClose",function(){
    //     $(".filestakQuery").hide();
    // });

    //Global Variables

    function alDataSet() {
        this.default = {
            dpi: '',
            imageMax: '',
            imageMin: '',
            fabricMaxWidth: '',
            fabricMaxHeight: '',
            fabricAdjustMaxWidth: '',
            fabricAdjustMaxHeight: '',
            zoomMax: '',
            serverSidePath: ''
        }
        this.cur = {
            formStep: 1,
            working: false,
            page: 0,
            pageState: [],
            adjustImage: '',
            moveX: 0,
            moveY: 0,
            totalPrice: 0,
            projectName: ''
        }
        this.generate = {
            list :[],
            layout: []
        }
        this.form = {
            ori: null,
            size: null,
            pageCount: null,
            ratio: null
        }
        this.price = {
            list: [
                {
                    size: '',
                    count: '',
                    price: ''
                }
            ]
        }
        this.image = {
            id: 0,
            list: [],
            fabricImages: []
        }
        this.fabric = {
            mainCanvas: '',
            adjustCanvas: '',
            exportCanvas: ''
        }
        this.layout = {
            folder: "",
            format: "",
            landscape: "",
            square: "",
            vertical: "",
            list: []
        }
        this.back = {
            list: []
        }
        this.page = {
            list: []
        }
    }

    let al = new alDataSet();

    //Functions

    alStart();

    function alStart() {
        alLoadingShow("Starting...");
        alGetData(function () {
            alLoadingHide();
            alBackgroundUpdateList();
            alCheckInput();
        });
    }

    function alCheckInput() {
        const url = new URL(window.location.href);
        let project = url.searchParams.get("project");
        let tempFile = url.searchParams.get("tempFile");
        let action = url.searchParams.get("action");

        if (project != null) {
            project = decodeURIComponent(project);
            alLoadingShow("Processing...<br> Please wait . It take a few minutes.");
            alProjectRestore(project);
        }
        else if (tempFile != null) {
            tempFile = decodeURIComponent(tempFile);
            alLoadingShow("Processing...<br> Please wait . It take a few minutes.");
            alProjectSave(tempFile);
        }
        else if (action != null) {
            $(".albumHeaderOpenBtnText").click();
        }
    }

    function alGetData(callBack = function () {
    }) {
        $.getJSON("https://canadaphotolab.com/wp-content/themes/printspace/data/photoBooks.json", function (data) {
            al.default = data.default;
            al.price = data.price;
            al.layout = data.layout;

            for (let i = 0; i < data.back.count; i++) {
                al.back.list.push(
                    {
                        id: i + 1,
                        src: data.back.folder + "background (" + (i + 1) + ")." + data.back.format
                    }
                );
            }

            callBack();
        });
    }

    function alFindeBestLayout(ratioList, areaWidth, areaHeigth, minGap, heightPadding, widthPadding, callback = function (layouts) { }) {

        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");

        //main opertaion

        var raitoChangeRange = Math.max.apply(null, ratioList) - Math.min.apply(null, ratioList);

        if (ratioList.length === 1) {
            //one frame

            callback(drawOne());
            alLoadingHide();
        }
        else {
            //more than one frame 

            findBestSugns(function (sugns) {
                callback(sugns);
                alLoadingHide();
            })

            // findBestPart(function(bestPart){
            //     callback(drawRects(findBest(ratioList,bestPart),"row",minGap,bestPart,areaWidth,areaHeigth));
            // });
        }

        //draw one
        function drawOne()
        {
            var sugnId = 1;
            var type = "one";
            var sugn = [];

            var clipWidth = areaWidth - (widthPadding * 2);
            var clipHeight = areaHeigth - (heightPadding * 2);
            var clipRatio = clipWidth / clipHeight;
            
            var imgRatio = ratioList[0];
            var imgHeight = 0;
            var imgWidth = 0;
            var imgLeft = 0;
            var imgTop = 0;

            //contain all
            if(imgRatio <= clipRatio)
            {
                imgHeight = clipHeight;
                imgWidth = clipHeight * imgRatio;

                imgLeft = (clipWidth - imgWidth)/2;
                imgLeft += widthPadding;
                
                imgTop = heightPadding;
            }
            else
            {
                imgWidth = clipWidth;
                imgHeight = imgWidth / imgRatio;

                imgLeft = widthPadding;

                imgTop = (clipHeight - imgHeight)/2;
                imgTop += heightPadding;
            }

            var rects = [[imgTop,imgLeft,imgWidth,imgHeight,imgWidth/imgHeight]];

            sugn.push({
                id: sugnId++,
                type: type,
                part: 1,
                rects: rects,
                coverage: coverRate(areaWidth, areaHeigth, rects),
                src: getView(rects)
            });

            
            //contain left

            clipWidth /= 2;
            clipRatio = clipWidth / clipHeight;

            if(imgRatio <= clipRatio)
            {
                imgHeight = clipHeight;
                imgWidth = clipHeight * imgRatio;

                imgLeft = (clipWidth - imgWidth)/2;
                imgLeft += widthPadding;
                
                imgTop = heightPadding;
            }
            else
            {
                imgWidth = clipWidth;
                imgHeight = imgWidth / imgRatio;

                imgLeft = widthPadding;

                imgTop = (clipHeight - imgHeight)/2;
                imgTop += heightPadding;
            }

            var rects = [[imgTop,imgLeft,imgWidth,imgHeight,imgWidth/imgHeight]];

            sugn.push({
                id: sugnId++,
                type: type,
                part: 1,
                rects: rects,
                coverage: coverRate(areaWidth, areaHeigth, rects),
                src: getView(rects)
            });
                
            
            //contain right

            if(imgRatio <= clipRatio)
            {
                imgHeight = clipHeight;
                imgWidth = clipHeight * imgRatio;

                imgLeft = (clipWidth - imgWidth)/2;
                imgLeft += clipWidth;
                imgLeft += widthPadding;

                imgTop = heightPadding;
            }
            else
            {
                imgWidth = clipWidth;
                imgHeight = imgWidth / imgRatio;

                imgLeft = clipWidth;
                imgLeft += widthPadding;

                imgTop = (clipHeight - imgHeight)/2;
                imgTop += heightPadding;
            }

            var rects = [[imgTop,imgLeft,imgWidth,imgHeight,imgWidth/imgHeight]];

            sugn.push({
                id: sugnId++,
                type: type,
                part: 1,
                rects: rects,
                coverage: coverRate(areaWidth, areaHeigth, rects),
                src: getView(rects)
            });


            return sugn;
        }

        //find best part

        function findBestPart(callback = function (bestPart) { }) {
            var partCounter = 1;
            var maxPart = 6;
            if (ratioList.length < 4) {
                maxPart = ratioList.length;
            }
            var partCoverage = [];

            getPartsCoverage();

            function getPartsCoverage() {
                partCoverage[partCounter] = coverRate(areaWidth, areaHeigth, drawRects(ratioList, "row", minGap, partCounter, areaWidth, areaHeigth))
                partCounter++;
                if (partCounter > maxPart) {
                    callback(partCoverage.indexOf(partCoverage.reduce((a, b) => Math.max(a, b), -Infinity)));
                }
                else {
                    getPartsCoverage();
                }
            }
        }

        //get suggustion

        function findBestSugns(callback = function (sugn) { }) {
            var partCounter = 1;
            var sugnId = 1;
            var maxPart = 8;
            var type = "row";

            if (ratioList.length < maxPart) {
                maxPart = ratioList.length;
            }

            var sugn = [];

            calculateSuggustion();

            function calculateSuggustion() {
                var ratios = ratioList;
                if (type === "col") {
                    ratios = [];
                    $.each(ratioList, function (index, item) {
                        ratios[index] = 1 / item;
                    });
                }
                var rects = drawRects(findBest(ratios, partCounter), type, minGap, partCounter, areaWidth, areaHeigth);
                var coverage = coverRate(areaWidth, areaHeigth, rects);
                var similarCoverage = false;
                if(sugn.length > 0)
                {
                    similarCoverage =  sugn.find(item => item.coverage <= (coverage + 0.05) && item.coverage >= (coverage - 0.05));
                    if(similarCoverage === undefined)
                    {
                        similarCoverage = false;
                    }
                }
                

                if( !(similarCoverage && raitoChangeRange <= 0.4) )
                {
                    sugn.push({
                        id: sugnId++,
                        type: type,
                        part: partCounter,
                        rects: rects,
                        coverage: coverage,
                        src: getView(rects)
                    });
                }

                partCounter++;

                if (partCounter > maxPart && type === "col") {
                    callback(sugn);
                }
                else if (partCounter > maxPart) {
                    // callback(sugn);
                    partCounter = 1;
                    type = "col";
                    calculateSuggustion();
                }
                else {
                    calculateSuggustion();
                }
            }

        }

        //get view

        function getView(rects) {
            //create

            let canvas = $("#generateView").get(0);
            canvas.width = areaWidth;
            canvas.height = areaHeigth;
            let fabricCanvas = new fabric.Canvas('generateView');
            fabricCanvas.set({
                uniScaleTransform: false,
                enableRetinaScaling: true,
                uniScaleKey: "none",
                selection: false,
                controlsAboveOverlay: true,
                backgroundColor: "#eee",
                perPixelTargetFind: true,
                preserveObjectStacking: true,
                containerClass: "generateView"
            });
            fabricCanvas.renderAll()

            //main 
            clearFabric();
            addRect();
            return (fabricCanvas.toDataURL());


            //add

            function addRect() {
                rects.forEach(function (item) {
                    let rect = new fabric.Rect(
                        {
                            top: item[0],
                            left: item[1],
                            width: item[2],
                            height: item[3],
                            fill: "#4cc2ce"
                        }
                    );
                    fabricCanvas.add(rect);
                    fabricCanvas.renderAll();
                });
            }

            //clear

            function clearFabric() {
                for (let i = fabricCanvas._objects.length - 1; i >= 0; i--) {
                    fabricCanvas.remove(fabricCanvas._objects[i]);
                }
            }
        }

        //find best

        function findBest(ratioList, rowCount) {
            let ratioListPer = permutations(ratioList);
            let rowCounter = 0;
            let rows = [];

            for (let j = 0; j < ratioListPer.length; j++) {
                ratioListPerItem = ratioListPer[j];

                let row = [];
                for (let i = 0; i < rowCount; i++)
                    row.push(0);

                for (let i = 0; i < ratioListPerItem.length; i++) {
                    if (rowCounter >= rowCount) {
                        rowCounter = 0;
                    }

                    row[rowCounter] += ratioListPerItem[i];

                    rowCounter++;
                }

                let temp = Math.max.apply(null, row) - Math.min.apply(null, row);
                rows.push(temp);
            }

            return (ratioListPer[rows.indexOf(Math.min.apply(null, rows))]);
        }

        // draw rects

        function drawRects(ratio, dir, gap, part, areaWidth, areaHeigth) {
            let rects = [];

            //layout padding
            areaHeigth -= heightPadding * 2;
            areaWidth -= widthPadding * 2;

            //col
            if (dir === "col") {

                var temp = areaHeigth;
                areaHeigth = areaWidth;
                areaWidth = temp;
            }

            let globHeight = (areaHeigth - (gap * (part - 1))) / part;
            let partRatioSum = [];

            let parts = [];
            for (let i = 0; i < part; i++)
                parts.push([]);
            partCounter = 0;
            for (let i = 0; i < ratio.length; i++) {
                if (partCounter >= part) {
                    partCounter = 0;
                }

                parts[partCounter].push(ratio[i]);

                partCounter++;
            }

            parts.forEach(function (item, i) {
                partRatioSum[i] = 0;
                item.forEach(function (item2) {
                    partRatioSum[i] += item2;
                });
            });

            maxRectsWidth = 0;
            maxRectsWidthId = 0;

            parts.forEach(function (item,i) {
                let max = 0;
                item.forEach(function (item2) {
                    max += globHeight * item2;
                });
                max += (gap * (item.length - 1));
                if (max > maxRectsWidth)
                {
                    maxRectsWidth = max;
                    maxRectsWidthId = i;
                }
            });
            
            //calculate height of each row

            var partsHeight = [];
            var partsHeightSum = 0;
            var avelHeight = globHeight * parts.length;


            parts.forEach(function (item, i) {
                var itemSum = 0;
                item.forEach(function(item2, i2){
                    itemSum+=item2;
                })
                var newHeight = (maxRectsWidth / itemSum);
                var gapDifrence = ( parts[maxRectsWidthId].length - item.length ) * gap;
                // gapDifrence *= newHeight/globHeight;

                partsHeight.push( (maxRectsWidth + (gapDifrence)) / itemSum ) ;

            });

            partsHeight.forEach(function (item, i) {
                partsHeightSum += item;
            });

            partsHeight.forEach(function (item, i) {
                partsHeight[i] = (partsHeight[i] * avelHeight) / partsHeightSum;
            });     

            //row gap
            var rowGap = gap * (areaHeigth / partsHeightSum);

            //new maxRectsWidth
            var ratioSum0 = 0;
            parts[0].forEach(function(item){
                ratioSum0 += item;
            })
            maxRectsWidth = (partsHeight[0] * ratioSum0) + ((parts[0].length - 1) * rowGap);

            //end calculate height of each row

            parts.forEach(function (item, i) {
                let avelWidth = areaWidth - (gap * (item.length - 1));
                let rectsWidth = 0;
                let lastRect = [0, 0, 0, 0];

                if (maxRectsWidth > avelWidth) {
                    maxRectsWidth = avelWidth;
                }

                item.forEach(function (item2, i2) {
                    rectsWidth += partsHeight[i] * item2;
                });

                if (rectsWidth > avelWidth) {
                    item.forEach(function (item2, i2) {
                        let rightMargin = rowGap;
                        if (i2 === 0)
                            rightMargin = 0;

                        let width = avelWidth * (item2 / partRatioSum[i]);
                        let height = width / item2;

                        lastRect = [
                            (partsHeight[i] * i) + (gap * i),
                            lastRect[1] + lastRect[2] + rightMargin,
                            width,
                            height,
                            item2
                        ];
                        rects.push(lastRect);
                    });
                }
                else if (rectsWidth < avelWidth) {
                    item.forEach(function (item2, i2) {
                        // let maxGap = ((maxRectsWidth - rectsWidth) / (item.length - 1))
                        // let rightMargin = maxGap;
                        // if (i2 === 0)
                        //     rightMargin = ((avelWidth + (gap * (item.length - 1))) - maxRectsWidth) / 2;

                        let rightMargin = rowGap;
                        if (i2 === 0)
                            rightMargin = ((avelWidth + (rowGap * (item.length - 1))) - maxRectsWidth) / 2;

                        lastRect = [
                            (partsHeight[i] * i) + (gap * i),
                            lastRect[1] + lastRect[2] + rightMargin,
                            partsHeight[i] * item2,
                            partsHeight[i],
                            item2
                        ];
                        rects.push(lastRect);
                    });
                }
                else {
                    item.forEach(function (item2, i2) {
                        let rightMargin = rowGap;
                        if (i2 === 0)
                            rightMargin = 0;
                        lastRect = [
                            (partsHeight[i] * i) + (gap * i),
                            lastRect[1] + lastRect[2] + rightMargin,
                            partsHeight[i] * item2,
                            partsHeight[i],
                            item2
                        ];
                        rects.push(lastRect);
                    });
                }
            });

            //horizental align
            var rectCounter = 0;
            var rectsHeight = [];
            var rectsHeightSum = 0;
            parts.forEach(function (item, i) {
                rectsHeightSum += rects[rectCounter][3];
                item.forEach(function (item2) {
                    rectsHeight[i] = rects[rectCounter][3];
                    rectCounter++;
                });
            });

            rectsHeightSum += (gap * (part - 1));
            rectCounter = 0;
            let lastTop = 0;
            parts.forEach(function (item, i) {
                let retcsTop = (areaHeigth - rectsHeightSum) / 2;
                if (i > 0)
                    retcsTop = lastTop + rectsHeight[i - 1] + gap;
                item.forEach(function (item2) {
                    rects[rectCounter][0] = retcsTop;
                    rectCounter++;
                });
                lastTop = rects[rectCounter - 1][0];
            });

           

            //col
            if (dir === "col") {
                for (var i = 0; i < rects.length; i++) {
                    var temp = rects[i][0];
                    rects[i][0] = rects[i][1];
                    rects[i][1] = temp;

                    temp = rects[i][2];
                    rects[i][2] = rects[i][3];
                    rects[i][3] = temp;
                }
            }

            //layout padding
            rects.forEach(function (item, i) {
                rects[i][0] += heightPadding;
                rects[i][1] += widthPadding;
            });

            return rects;

        }

        //coverRate

        function coverRate(areaWidth, areaHeigth, rects) {
            area = areaHeigth * areaWidth;
            rectsArea = 0;
            rects.forEach(function (item, i) {
                rectsArea += item[2] * item[3];
            });

            return rectsArea / area;
        }

        //permutations

        function permutations(arr) {
            if (arr.length <= 2) return arr.length === 2 ? [arr, [arr[1], arr[0]]] : arr;
            return arr.reduce(
                (acc, item, i) =>
                    acc.concat(
                        permutations([...arr.slice(0, i), ...arr.slice(i + 1)]).map(val => [
                            item,
                            ...val,
                        ])
                    ),
                []
            );
        };

    }

    function alLayoutTracking(imageSrc, callBackfunc = function (rects) {
    }) {
        let rects = [];
        rects.length = 0;
        let img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = imageSrc;
        img.onload = function () {
            let trackCanvas = document.createElement('canvas');
            let trackContext = trackCanvas.getContext('2d');
            trackCanvas.width = img.width;
            trackCanvas.height = img.height;
            trackContext.drawImage(img, 0, 0);
            let myData = trackContext.getImageData(0, 0, img.width, img.height);
            myData = myData.data;

            for (let i = 0; i < myData.length; i = i + 4) {
                let cDefDot = defDot(i);
                if (!isWhite(i) && cDefDot !== -1) {
                    if (cDefDot === 1) {
                        rects.push([getPX(i), getPY(i), -1, -1, -1, -1]);
                    } else if (cDefDot === 2) {
                        rects[rects.length - 1][4] = getPX(i);
                        rects[rects.length - 1][5] = getPY(i);
                    } else if (cDefDot === 3) {
                        let trg = findTop(getPX(i), "left");
                        if (trg !== undefined)
                            rects[trg][3] = getPY(i) - rects[trg][1];
                    } else if (cDefDot === 4) {
                        let trg = findTop(getPX(i), "right");
                        if (trg !== undefined) {
                            rects[trg][2] = getPX(i) - rects[trg][0];
                            rects[trg].length = 4;
                        }
                    }
                }
            }
            resizeToFabricCanvas(rects);
            callBackfunc(rects);

            function isWhite(id) {
                return myData[id] > 245 && myData[id + 1] > 245 && myData[id + 2] > 245;
            }

            function pxIsWhite(dir, id) {
                if (dir === "top") {
                    let topId = id - (img.width * 4);
                    if (topId < 0)
                        return true;
                    else
                        return isWhite(topId);
                } else if (dir === "right") {
                    let ritId = id + 4;
                    if (id === 0)
                        return isWhite(ritId);
                    if (((ritId / 4) + 1) % img.width === 1)
                        return true;
                    else if (ritId === img.width * img.height * 4)
                        return true;
                    else
                        return isWhite(ritId);
                } else if (dir === "bottom") {
                    let botId = id + (img.width * 4);
                    if (botId + 1 > myData.length)
                        return true;
                    else
                        return isWhite(botId);
                } else if (dir === "left") {
                    let lfId = id - 4;
                    if (lfId === 0)
                        return isWhite(lfId);
                    if (lfId < 0)
                        return true;
                    else if (((lfId / 4) + 1) % img.width === 0)
                        return true;
                    else
                        return isWhite(lfId);
                } else {
                    return undefined;
                }
            }

            function defDot(id) {
                if (pxIsWhite("top", id) && !pxIsWhite("right", id) && !pxIsWhite("bottom", id) && pxIsWhite("left", id)) {
                    return 1;
                } else if (pxIsWhite("top", id) && pxIsWhite("right", id) && !pxIsWhite("bottom", id) && !pxIsWhite("left", id)) {
                    return 2;
                } else if (!pxIsWhite("top", id) && !pxIsWhite("right", id) && pxIsWhite("bottom", id) && pxIsWhite("left", id)) {
                    return 3;
                } else if (!pxIsWhite("top", id) && pxIsWhite("right", id) && pxIsWhite("bottom", id) && !pxIsWhite("left", id)) {
                    return 4;
                } else
                    return -1;
            }

            function getPX(id) {
                return (id / 4) % img.width;
            }

            function getPY(id) {
                return Math.ceil((id / 4) / img.width)
            }

            function findTop(PX, dir) {
                let trsh = 2;
                let target = undefined;
                if (dir === "left")
                    dir = 0;
                else if (dir === "right")
                    dir = 4;
                for (let i = 0; i < rects.length; i++)
                    if (rects[i][dir] - PX < trsh && rects[i][dir] - PX > -trsh)
                        target = i;
                return target;
            }

            function resizeToFabricCanvas(rects) {
                let widRate = al.fabric.mainCanvas.width / img.width;
                let hgtRate = al.fabric.mainCanvas.height / img.height;
                for (let i = 0; i < rects.length; i++) {
                    rects[i][0] = rects[i][0] * widRate;
                    rects[i][1] = rects[i][1] * hgtRate;
                    rects[i][2] = rects[i][2] * widRate;
                    rects[i][3] = rects[i][3] * hgtRate;
                }
            }
        }
        img.onerror = function () {
            console.log("Layout Tracking Error: Can't read layout image : " + imageSrc);
            callBackfunc(null);
            return false;
        }
    }

    function alLayoutGetData(callback = function () { }) {
        let layoutCounter = 1;
        al.layout.list = [];
        let Ori = al.form.ori;
        let layoutCount = al.layout[Ori];
        let layoutFolder = al.layout.folder;
        let layoutFormat = al.layout.format;

        alLoadingShow("Preparing Album...");

        alLayoutTracking(
            layoutFolder + Ori + " (" + layoutCounter + ")." + layoutFormat,
            function (rects) {
                alLayoutAdd(rects);
            });

        function alLayoutAdd(rects) {
            if (rects !== null) {
                let clips = [];
                for (let i = 0; i < rects.length; i++) {
                    clips.push(
                        new fabric.Rect({
                            left: rects[i][0],
                            top: rects[i][1],
                            width: rects[i][2],
                            height: rects[i][3],
                            absolutePositioned: true
                        })
                    )
                }
                al.layout.list.push({
                    id: layoutCounter,
                    src: layoutFolder + Ori + " (" + layoutCounter + ")." + layoutFormat,
                    count: rects.length,
                    clips: clips
                });
            }

            if (layoutCounter < layoutCount) {
                alLoadingShow("Preparing Album  " + Math.round((layoutCounter / layoutCount) * 100) + "%");
                layoutCounter++;
                alLayoutTracking(
                    layoutFolder + Ori + " (" + layoutCounter + ")." + layoutFormat,
                    function (rects) {
                        alLayoutAdd(rects);
                    });
            } else {
                callback();
                alLoadingHide();
            }
        }
    }

    function alFormProgressUpdate() {
        let temp = $(".albumFormHeaderProgress").children();
        $(temp).removeClass("albumFormHeaderProgressItemActive");

        for (let i = 0; i < al.cur.formStep; i++)
            $(temp[i]).addClass("albumFormHeaderProgressItemActive");
    }

    function alFormBackBtnUpdate() {
        if (al.cur.formStep === 2 || al.cur.formStep === 3)
            $(".albumFormHeaderBackBtn").show();
        else
            $(".albumFormHeaderBackBtn").hide();
    }

    function alFormBackBtnClick() {
        $(".albumFormStep" + al.cur.formStep).hide();
        al.cur.formStep -= 1;
        $(".albumFormStep" + al.cur.formStep).show();

        alFormProgressUpdate();
        alFormBackBtnUpdate();
    }

    function alFormStep1ChangeOpt(elm) {
        $(".albumFormStep1Opts").find(".albumFormStep1OptActive").removeClass("albumFormStep1OptActive");
        $(elm).addClass("albumFormStep1OptActive");
    }

    function alFormStep1Btn() {
        al.form.ori = $(".albumFormStep1OptActive").attr("data-val");
        if (al.form.ori === undefined) {
            console.log('Album Error : Can\'t Set Orientation ');
            return;
        }

        $(".albumFormStep1").hide();
        alFormStep2Show();
    }

    function alFormStep2Show() {
        al.cur.formStep = 2;

        $(".albumFormStep2Opts").hide();
        $(".albumFormStep2Opts").find(".albumFormStep2OptActive").removeClass("albumFormStep2OptActive");

        let temp = $(".albumFormStep2").find("[data-ori=" + al.form.ori + "]");
        $(temp).show();
        $(temp).children().first().addClass("albumFormStep2OptActive");

        alFormBackBtnUpdate();
        alFormProgressUpdate();
        $(".albumFormStep2").show();
    }

    function alFormStep2ChangeOpt(elm) {
        $(".albumFormStep2Opts").find(".albumFormStep2OptActive").removeClass("albumFormStep2OptActive");
        $(elm).addClass("albumFormStep2OptActive");
    }

    function alFormStep2Btn() {
        al.form.size = $(".albumFormStep2OptActive").attr("data-val");
        al.form.ratio = al.form.size.split("-");
        al.form.ratio = al.form.ratio[0] / al.form.ratio[1];
        al.selectedSizePrev = $(".albumFormStep2OptActive").attr("data-prev");

        $(".albumFormStep2").hide();

        alFormStep3Show();
    }

    function alFormStep3Show() {
        al.cur.formStep = 3;

        let priceList = al.price.list.filter(item => item.size === al.form.size);

        $(".albumFormStep3Opts").html("");
        for (let i = 0; i < priceList.length; i++) {
            let active = "";
            if (i === 0) active = "albumFormStep3OptActive";

            let mp = "";
            if (priceList[i].mostPopular !== undefined)
                mp = '    <div class="albumFormStep3OptPopular"><< Most Popular!</div>';

            $(".albumFormStep3Opts").append('' +
                '<div class="albumFormStep3Opt ' + active + ' clearBoth" data-val="' + priceList[i].count + '" data-price="' + priceList[i].price + '">' +
                '    <div class="albumFormStep3OptCount">' + priceList[i].count + ' spreads (' + (priceList[i].count * 2) + ' pages)</div>' +
                '    <div class="albumFormStep3OptPrice">$' + priceList[i].price + '</div>' +
                mp +
                '</div>');
        }

        $(".albumFormStep3").show();

        alFormBackBtnUpdate();
        alFormProgressUpdate();
    }

    function alFormStep3ChangeOpt(elm) {
        $(".albumFormStep3Opts").find(".albumFormStep3OptActive").removeClass("albumFormStep3OptActive");
        $(elm).addClass("albumFormStep3OptActive");
    }

    function alFormStep3Btn() {
        al.form.pageCount = $(".albumFormStep3OptActive").attr("data-val");
        al.cur.totalPrice = $(".albumFormStep3OptActive").attr("data-price");

        $(".albumForm").hide()

        alWorkAreaShow();
    }

    function alWorkAreaShow() {
        $(".albumWorkArea").show();
        $("#albumWorkShop").addClass("albumHeaderProgressItemActive");

        al.cur.working = true;
        alFabricCreate();
        alPagePreparing();
        alFinishShow();
        alProjectNameSync();
    }

    function alFinishShow() {
        $(".albumHeaderFinishTotalPrice").html("$" + al.cur.totalPrice);
        $(".albumHeaderFinish").show();
    }

    function alFileDragOver() {
        $(".albumFooterImagesDropCon").addClass("albumFooterImagesDropConDrag");
    }

    function alFileDragLeave() {
        $(".albumFooterImagesDropCon").removeClass("albumFooterImagesDropConDrag");
    }

    function alLoadingShow(text = "Loading...") {
        $('.albumLoadingText').html(text);
        $('.albumLoading').show();
    }

    function alLoadingHide() {
        $('.albumLoading').hide();
    }

    function alFileAdd(fileList) {
        alLoadingShow("Processing images...");
        al.cur.working = true;
        alFileDragLeave();

        let count = 0;
        alFileAddOneFile(fileList[count]);

        function alFileAddOneFile(cFile) {

            if (count >= fileList.length) {
                $("#albumFooterImagesDropFile").val("");
                alImageListUpdate();
                alFileDropCheck();
                alLoadingHide();
                return;
            }

            if (!cFile.type.match('image')) {
                alert(cFile.name + " is not image file.");
                count++;
                alFileAddOneFile(fileList[count]);
                return;
            }

            let picReader = new FileReader();
            picReader.readAsDataURL(cFile);

            picReader.onload = function () {

                let thumbImg = new Image();
                thumbImg.crossOrigin = 'anonymous';
                thumbImg.src = picReader.result;
                thumbImg.onload = function () {

                    let maxWidht = al.default.fabricMaxWidth;
                    let maxHeigth = al.default.fabricMaxHeight;
                    let maxRatio = maxWidht / maxHeigth;

                    let imageWidth = thumbImg.width;
                    let imageHeigth = thumbImg.height;
                    let imageRatio = imageWidth / imageHeigth;

                    let scale;
                    if (imageRatio <= maxRatio)
                        scale = maxWidht / imageWidth;
                    else
                        scale = maxHeigth / imageHeigth;


                    let width = thumbImg.width *= scale;
                    let height = thumbImg.height *= scale;

                    let thumbCanvas = document.createElement("canvas");
                    thumbCanvas.width = width;
                    thumbCanvas.height = height;

                    let thumbCanvasCtx = thumbCanvas.getContext("2d");
                    thumbCanvasCtx.drawImage(thumbImg, 0, 0, width, height);
                    thumbImg.src = thumbCanvas.toDataURL('image/jpeg');

                    thumbImg.onload = function () {
                        let id = al.image.id++;

                        al.image.list.push({
                            id: id,
                            name: cFile.name,
                            lastModified: cFile.lastModified,
                            src: picReader.result,
                            thumbSrc: thumbImg.src,
                            state: false,
                            filters: [],
                            ratio: imageWidth / imageHeigth
                        });

                        count++;
                        alFileAddOneFile(fileList[count]);
                    }
                }
            }
            picReader.onerorr = function () {
                alert("Can't read this file : " + cFile.name);
                count++;
                alFileAddOneFile(fileList[count]);
            }
        }
    }

    function alImageListUpdate() {
        $(".albumFooterImagesList").html("");
        al.cur.working = true;

        let sortKey = $("#albumFooterOptFilter").val();

        al.image.list.sort((a, b) => (a[sortKey] > b[sortKey]) ? 1 : ((b[sortKey] > a[sortKey]) ? -1 : 0));

        for (let i = 0; i < al.image.list.length; i++) {
            let usedCalss = "";
            if (al.image.list[i].state)
                usedCalss = "albumFooterImageUsed";
            $(".albumFooterImagesList").append(
                "<div class='" + usedCalss + "' id='image" + al.image.list[i].id + "' data-modified='" + al.image.list[i].lastModified + "' data-name='" + al.image.list[i].name + "'>" +
                "   <img src='" + al.image.list[i].thumbSrc + "'>" +
                "</div>"
            );
        }

        //check used images
        let imageCat = $("#albumFooterOptImageCat").val();
        if (imageCat === "used") {
            $(".albumFooterImagesList").children(":not(.albumFooterImageUsed)").hide();
        } else if (imageCat === "unused") {
            $(".albumFooterImagesList").children(".albumFooterImageUsed").hide();
        }


        $(".albumFooterImagesList").selectable({
            filter: "div:not(.albumFooterImageUsed)"
        });
        $(".albumFooterImagesList").children().draggable({
            revert: true,
            iframeFix: true,
            cancel: "div.albumFooterImageUsed"
        });

        alFileDropCheck();
    }

    function alFileDropCheck() {
        if ($(".albumFooterImagesList").children().length === 0) {
            $(".albumFooterImagesDrop").show();
            $(".albumFooterImagesList").hide();
        } else {
            $(".albumFooterImagesDrop").hide();
            $(".albumFooterImagesList").show();
        }
    }

    function alImageListResize() {
        let ratio = $(".albumFooterOptZoomSlider").val();

        let min = al.default.imageMin;
        let max = al.default.imageMax;

        let width = min + ((max - min) * ratio);

        $(".albumFooterImagesList>div").css("width", width + "px");
        $(".albumFooterImagesList>div").css("height", width + "px");
    }

    function alImageListClick(elm) {
        if ($(elm).hasClass("ui-selected"))
            $(elm).removeClass("ui-selected");
        else
            $(elm).addClass("ui-selected");
    }

    function alFabricCreate() {
        //main canvas

        let canvas = $("#albumMainCanvas").get(0);
        if ((al.default.fabricMaxWidth / 2) / al.form.ratio <= al.default.fabricMaxHeight) {
            canvas.width = al.default.fabricMaxWidth;
            canvas.height = (al.default.fabricMaxWidth / 2) / al.form.ratio;
        } else {
            canvas.width = (al.default.fabricMaxHeight * al.form.ratio) * 2;
            canvas.height = al.default.fabricMaxHeight;
        }

        $(".albumPageImages").css("width", canvas.width + "px");
        al.fabric.mainCanvas = new fabric.Canvas('albumMainCanvas');

        al.fabric.mainCanvas.set({
            uniScaleTransform: true,
            enableRetinaScaling: true,
            uniScaleKey: "none",
            selection: false,
            containerClass: "albumMainCanvasArea",
            controlsAboveOverlay: false,
            backgroundColor: "#ffffff",
            perPixelTargetFind: false,
            preserveObjectStacking: true
        });

        al.fabric.mainCanvas.backgroundColor.repeat = 'repeat';

        al.fabric.mainCanvas.renderAll();

        //guid line
        alFabricAligningGuidelines(al.fabric.mainCanvas);

        //main canvas actions
        al.fabric.mainCanvas.on("object:moving", function (options) {
            if (options.target !== null)
                if (options.target.type === "rect")
                    // alImagePreventOverflow(options);
                    alFabricMoveSync(options);
        });
        al.fabric.mainCanvas.on("mouse:down", function (options) {
            alDesignZoomSync(options);
            alAdjustSync(options);
            alFabricMoveSync(options);
            alDesignMenuSync();
        });
        al.fabric.mainCanvas.on("selection:cleared", function () {
            alAdjustSync();
            alDesignMenuSync();
        });
        al.fabric.mainCanvas.on("object:scaling", function (options) {
            if (options !== null)
                if (options.transform.target.type === "rect") {
                    alFabricScaleToOne(options.transform.target);

                    let clipId = al.fabric.mainCanvas._objects.indexOf(options.transform.target);
                    alImageFit(clipId);
                }
            alFabricMoveSync(options.transform);
        });
        al.fabric.mainCanvas.on("object:modified", function (options) {
            if (options !== null)
                if (options.transform.target.type === "rect") {
                    alFabricScaleToOne(options.transform.target);

                    let clipId = al.fabric.mainCanvas._objects.indexOf(options.transform.target);
                    alImageFit(clipId);
                }
            alFabricMoveSync(options.transform);
        });
        al.fabric.mainCanvas.on("mouse:over", function (options) {
            // alFabricMoveSync(options);
        });

        //create move icon
        alFabricMoveCreat();

        //adjust canvas
        canvas = $("#albumAdjustImage").get(0);
        canvas.width = al.default.fabricAdjustMaxWidth;
        canvas.height = al.default.fabricAdjustMaxHeight;

        al.fabric.adjustCanvas = new fabric.Canvas('albumAdjustImage');

        al.fabric.adjustCanvas.set({
            uniScaleTransform: false,
            enableRetinaScaling: true,
            uniScaleKey: "none",
            selection: false,
            containerClass: "albumAdjustImageArea",
            controlsAboveOverlay: true,
            backgroundColor: "#ffffff",
            perPixelTargetFind: false
        });

        al.fabric.adjustCanvas.renderAll();
    }

    function alFabricMoveCreat() {
        let img = new Image();
        img.src = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNC4yLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDM5OCAzOTgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDM5OCAzOTg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtvcGFjaXR5OjAuNTtmaWxsOiNGRkZGRkY7fQ0KCS5zdDF7ZmlsbDojNTU1NTU1O30NCjwvc3R5bGU+DQo8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIxOTkiIGN5PSIxOTkiIHI9IjE5OSIvPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0zNzAuOCwxOTEuNmwtNTcuMi01My44Yy0yLjktMi44LTcuMi0zLjUtMTAuOS0xLjljLTMuNywxLjYtNi4xLDUuMi02LjEsOS4zdjIzLjZoLTY3LjN2LTY3LjNoMjMuNg0KCQkJYzQsMCw3LjctMi40LDkuMy02LjFjMS42LTMuNywwLjgtOC0xLjktMTAuOWwtNTMuOC01Ny4yYy0xLjktMi00LjYtMy4yLTcuNC0zLjJzLTUuNCwxLjEtNy40LDMuMmwtNTMuOCw1Ny4yDQoJCQljLTIuOCwyLjktMy41LDcuMi0xLjksMTAuOWMxLjYsMy43LDUuMiw2LjEsOS4zLDYuMWgyMy42djY3LjNoLTY3LjN2LTIzLjZjMC00LTIuNC03LjctNi4xLTkuM2MtMy43LTEuNi04LTAuOC0xMC45LDEuOQ0KCQkJbC01Ny4yLDUzLjhjLTIsMS45LTMuMiw0LjYtMy4yLDcuNGMwLDIuOCwxLjEsNS40LDMuMiw3LjRsNTcuMiw1My44YzIuOSwyLjgsNy4yLDMuNSwxMC45LDEuOWMzLjctMS42LDYuMS01LjIsNi4xLTkuM3YtMjMuNg0KCQkJaDY3LjN2NjcuM2gtMjMuNmMtNCwwLTcuNywyLjQtOS4zLDYuMWMtMS42LDMuNy0wLjgsOCwxLjksMTAuOWw1My44LDU3LjJjMS45LDIsNC42LDMuMiw3LjQsMy4yczUuNC0xLjEsNy40LTMuMmw1My44LTU3LjINCgkJCWMyLjgtMi45LDMuNS03LjIsMS45LTEwLjljLTEuNi0zLjctNS4yLTYuMS05LjMtNi4xaC0yMy42di02Ny4zaDY3LjN2MjMuNmMwLDQsMi40LDcuNyw2LjEsOS4zYzMuNywxLjYsOCwwLjgsMTAuOS0xLjlsNTcuMi01My44DQoJCQljMi0xLjksMy4yLTQuNiwzLjItNy40UzM3Mi45LDE5My42LDM3MC44LDE5MS42eiIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K";

        $("#albumMainCanvas").parent().append("<img style='z-index: 5;position: absolute;width: 25px;cursor:pointer;' id='albumMoveIcon' src='" + img.src + "'/>");
        $("#albumMoveIcon").hide();

        $("#albumMoveIcon").draggable({
            drag: function (e) {
                alFabricMoveDrag(e);
            }
        });


        // fabric.Object.prototype.controls.deleteControl = new fabric.Control({
        //     x: 0,
        //     y: 0,
        //     cursorStyle: 'pointer',
        //     mouseUpHandler: moveObject,
        //     render: renderIcon,
        //     cornerSize: 24
        // });
        //
        // function moveObject(eventData, transform) {
        //     let target = transform.target;
        //     let canvas = target.canvas;
        //     canvas.remove(target);
        //     canvas.requestRenderAll();
        // }
        //
        // function renderIcon(ctx, left, top, styleOverride, fabricObject) {
        //     var size = this.cornerSize;
        //     ctx.save();
        //     ctx.translate(left, top);
        //     ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
        //     ctx.drawImage(img, -size/2, -size/2, size, size);
        //     ctx.restore();
        // }
    }

    function alFabricMoveSync(options = null) {

        let clip = '';
        if (options === null) {
            clip = al.fabric.mainCanvas.getActiveObject();
        }
        else if (options.target !== null) {
            clip = options.target;
        }
        else {
            $("#albumMoveIcon").hide();
            return;
        }

        if (clip === null || clip === undefined) {
            $("#albumMoveIcon").hide();
            return;
        }

        if (clip.type !== "rect") {
            $("#albumMoveIcon").hide();
            return;
        }


        let clipId = al.fabric.mainCanvas._objects.indexOf(clip);
        let offsetX = -al.image.fabricImages[clipId].offsetX;
        let offsetY = -al.image.fabricImages[clipId].offsetY;
        let left = $(".albumCanvasFabric").offset().left + al.cur.moveX - offsetX;
        let top = $(".albumCanvasFabric").offset().top + al.cur.moveY - offsetY;


        al.cur.moveX = clip.left + (clip.width / 2) - 12.5;
        al.cur.moveY = clip.top + (clip.height / 2) - 12.5;


        $("#albumMoveIcon").css("left", al.cur.moveX);
        $("#albumMoveIcon").css("top", al.cur.moveY);

        $("#albumMoveIcon").draggable("option", "containment", [left, top, left + (offsetX * 2), top + (offsetY * 2)]);

        $("#albumMoveIcon").show();
    }

    function alFabricMoveDrag(e) {
        let dragX = e.originalEvent.clientX - $(".albumCanvasFabric").offset().left;
        let dragY = e.originalEvent.clientY - $(".albumCanvasFabric").offset().top;
        let clipX = al.cur.moveX;
        let clipY = al.cur.moveY;

        let clipIndex = al.fabric.mainCanvas._objects.indexOf(al.fabric.mainCanvas.getActiveObject());

        al.image.fabricImages[clipIndex].movedX = dragX - clipX;
        al.image.fabricImages[clipIndex].movedY = dragY - clipY;

        alImageFit(clipIndex);
    }

    function alFabricScaleToOne(clip) {
        clip.width = clip.scaleX * clip.width;
        clip.height = clip.scaleY * clip.height;
        clip.scaleX = 1;
        clip.scaleY = 1;
        al.fabric.mainCanvas.renderAll();
    }

    function alFabricCleanCanvas() {
        for (let i = al.fabric.mainCanvas._objects.length - 1; i >= 0; i--) {
            al.fabric.mainCanvas.remove(al.fabric.mainCanvas._objects[i]);
        }
        al.image.fabricImages = [];
    }

    function alFabricAdd(imageWrapper, clipPath, callBack = function () { }) {
        al.cur.working = true;

        //preaparing to add image
        let imageId = $(imageWrapper).attr("id");
        if (imageId === undefined)
            return;
        imageId = parseInt(imageId.replace("image", ""));

        imageId = al.image.list.findIndex(item => item.id === imageId);
        al.image.list[imageId].state = true;

        $(imageWrapper).addClass("albumFooterImageUsed");
        $(imageWrapper).removeClass("ui-selected");

        let clip = new fabric.Rect({
            left: clipPath.left,
            top: clipPath.top,
            width: clipPath.width,
            height: clipPath.height,
            centeredRotation: true,
            objectCaching: false,
            cornerStyle: "circle",
            cornerSize: 8,
            borderColor: "#555555",
            cornerColor: "#4cc2ce",
            cornerStrokeColor: "#4cc2ce",
        });


        al.fabric.mainCanvas.add(clip);
        al.fabric.mainCanvas.renderAll();

        let objectId = al.fabric.mainCanvas._objects.length - 1;

        //set active
        al.fabric.mainCanvas.setActiveObject(al.fabric.mainCanvas._objects[objectId]);
        alDesignMenuSync();

        //save image source
        al.image.fabricImages[objectId] = {
            id: $(imageWrapper).attr("id").replace("image", ""),
            offsetX: 0,
            offsetY: 0,
            movedX: 0,
            movedY: 0
        };

        //fit image
        alImageFit(objectId);

        //scale state
        al.cur.pageState[objectId] = {
            scale: al.fabric.mainCanvas._objects[objectId].scaleX
        };

        alPageSave();
        alLayoutListUpdate();
        alPageImageListUpdate();
        alImageListUpdate();
        callBack();
    }

    function alFabricAddMore(imageWrapper, left, top) {
        al.cur.working = true;

        $(".albumCanvas").show();
        $(".albumDropBox").hide();
        $(".albumHeaderPreview").show();


        let image = $(imageWrapper).find("img").get(0);


        let height = image.naturalHeight;
        let width = image.naturalWidth;
        let ratio = width / height;
        let defSize = 200;

        if (ratio == 1) {
            width = defSize;
            height = defSize;
        } else if (ratio < 1) {
            width = defSize * ratio;
            height = defSize;
        } else if (ratio > 1) {
            width = defSize;
            height = defSize / ratio;
        }

        if (left + width > al.fabric.mainCanvas.width)
            left = al.fabric.mainCanvas.width - width - 10;

        if (top + height > al.fabric.mainCanvas.height)
            top = al.fabric.mainCanvas.height - height - 10;

        let clipPath = new fabric.Rect({
            left: left,
            top: top,
            width: width,
            height: height
        });
        alFabricAdd(imageWrapper, clipPath);

    }

    function alFabricRemove(target) {
        al.cur.working = true;

        let object = al.fabric.mainCanvas._objects[target];
        let id = al.image.fabricImages[target].id;


        $(".albumFooterImagesList").find("#image" + id).removeClass("albumFooterImageUsed");

        for (let i = target; i < al.fabric.mainCanvas._objects.length - 1; i++)
            al.image.fabricImages[i].id = al.image.fabricImages[i + 1].id;

        al.image.list[id].state = false;
        al.image.list[id].filters = [];

        al.cur.pageState.splice(target, 1);

        al.fabric.mainCanvas.remove(object);

        al.fabric.mainCanvas.renderAll();

        alPageSave();
        alLayoutListUpdate();
        alFabricMoveSync();
    }

    function alFabricDrop(imageWrapper, target, curX, curY) {
        al.cur.working = true;

        if (imageWrapper.length === 0) {
            return;
        }

        if (target === "") {
            target = -1;
            let objects = alFabricGetImageObjects();
            for (let i = 0; i < objects.length; i++) {
                let clip = objects[i];
                if (
                    curX >= clip.left && curX <= clip.width + clip.left &&
                    curY >= clip.top && curY <= clip.height + clip.top
                ) {
                    target = i;
                    break;
                }
            }
        }

        if (target !== -1 && al.fabric.mainCanvas._objects[target].isType("rect")) {
            alFabricReplace(imageWrapper, target);
            return;
        }

        alFabricAddMore(imageWrapper, curX, curY);
    }

    function alFabricReplace(imageWrapper, target) {
        al.cur.working = true;

        let clip = al.fabric.mainCanvas._objects[target];

        alFabricRemove(target);

        alFabricAdd(imageWrapper, clip);

        alPageImageListUpdate();
        alImageListUpdate();
    }

    function alFabricGetImageObjects() {
        let list = [];
        let objects = al.fabric.mainCanvas._objects;

        for (let i = 0; i < objects.length; i++)
            if (objects[i].isType("rect"))
                list.push(objects[i]);

        return list;
    }

    function alFabricChangeDimention(target, dimention) {
        al.cur.working = true;

        let clip = al.fabric.mainCanvas._objects[target];
        clip.set({
            top: dimention.top,
            left: dimention.left,
            width: dimention.width,
            height: dimention.height
        });

        al.fabric.mainCanvas.renderAll();

        alImageFit(target);
    }

    function alFabricAligningGuidelines(canvas) {
        var ctx = canvas.getSelectionContext(),
            aligningLineOffset = 5,
            aligningLineMargin = 4,
            aligningLineWidth = 1,
            aligningLineColor = 'rgb(69,199,207)',
            viewportTransform,
            zoom = 1;

        function drawVerticalLine(coords) {
            drawLine(
                coords.x + 0.5,
                coords.y1 > coords.y2 ? coords.y2 : coords.y1,
                coords.x + 0.5,
                coords.y2 > coords.y1 ? coords.y2 : coords.y1);
        }

        function drawHorizontalLine(coords) {
            drawLine(
                coords.x1 > coords.x2 ? coords.x2 : coords.x1,
                coords.y + 0.5,
                coords.x2 > coords.x1 ? coords.x2 : coords.x1,
                coords.y + 0.5);
        }

        function drawLine(x1, y1, x2, y2) {
            ctx.save();
            ctx.lineWidth = aligningLineWidth;
            ctx.strokeStyle = aligningLineColor;
            ctx.beginPath();
            ctx.moveTo(((x1 + viewportTransform[4]) * zoom), ((y1 + viewportTransform[5]) * zoom));
            ctx.lineTo(((x2 + viewportTransform[4]) * zoom), ((y2 + viewportTransform[5]) * zoom));
            ctx.stroke();
            ctx.restore();
        }

        function isInRange(value1, value2) {
            value1 = Math.round(value1);
            value2 = Math.round(value2);
            for (var i = value1 - aligningLineMargin, len = value1 + aligningLineMargin; i <= len; i++) {
                if (i === value2) {
                    return true;
                }
            }
            return false;
        }

        var verticalLines = [],
            horizontalLines = [];

        canvas.on('mouse:down', function () {
            viewportTransform = canvas.viewportTransform;
            zoom = canvas.getZoom();
        });

        function guide(e) {
            var activeObject = e.target,
                canvasObjects = canvas.getObjects(),
                activeObjectCenter = activeObject.getCenterPoint(),
                activeObjectLeft = activeObjectCenter.x,
                activeObjectTop = activeObjectCenter.y,
                activeObjectBoundingRect = activeObject.getBoundingRect(),
                activeObjectHeight = activeObjectBoundingRect.height / viewportTransform[3],
                activeObjectWidth = activeObjectBoundingRect.width / viewportTransform[0],
                horizontalInTheRange = false,
                verticalInTheRange = false,
                transform = canvas._currentTransform;

            if (!transform) return;

            // It should be trivial to DRY this up by encapsulating (repeating) creation of x1, x2, y1, and y2 into functions,
            // but we're not doing it here for perf. reasons -- as this a function that's invoked on every mouse move

            for (var i = canvasObjects.length; i--;) {

                if (canvasObjects[i] === activeObject) continue;

                var objectCenter = canvasObjects[i].getCenterPoint(),
                    objectLeft = objectCenter.x,
                    objectTop = objectCenter.y,
                    objectBoundingRect = canvasObjects[i].getBoundingRect(),
                    objectHeight = objectBoundingRect.height / viewportTransform[3],
                    objectWidth = objectBoundingRect.width / viewportTransform[0];

                // snap by the horizontal center line
                if (isInRange(objectLeft, activeObjectLeft)) {
                    verticalInTheRange = true;
                    verticalLines.push({
                        x: objectLeft,
                        y1: (objectTop < activeObjectTop)
                            ? (objectTop - objectHeight / 2 - aligningLineOffset)
                            : (objectTop + objectHeight / 2 + aligningLineOffset),
                        y2: (activeObjectTop > objectTop)
                            ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
                            : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
                    });
                    activeObject.setPositionByOrigin(new fabric.Point(objectLeft, activeObjectTop), 'center', 'center');
                }

                // snap by the left edge
                if (isInRange(objectLeft - objectWidth / 2, activeObjectLeft - activeObjectWidth / 2)) {
                    verticalInTheRange = true;
                    verticalLines.push({
                        x: objectLeft - objectWidth / 2,
                        y1: (objectTop < activeObjectTop)
                            ? (objectTop - objectHeight / 2 - aligningLineOffset)
                            : (objectTop + objectHeight / 2 + aligningLineOffset),
                        y2: (activeObjectTop > objectTop)
                            ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
                            : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
                    });
                    activeObject.setPositionByOrigin(new fabric.Point(objectLeft - objectWidth / 2 + activeObjectWidth / 2, activeObjectTop), 'center', 'center');
                }

                // snap by the right edge
                if (isInRange(objectLeft + objectWidth / 2, activeObjectLeft + activeObjectWidth / 2)) {
                    verticalInTheRange = true;
                    verticalLines.push({
                        x: objectLeft + objectWidth / 2,
                        y1: (objectTop < activeObjectTop)
                            ? (objectTop - objectHeight / 2 - aligningLineOffset)
                            : (objectTop + objectHeight / 2 + aligningLineOffset),
                        y2: (activeObjectTop > objectTop)
                            ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
                            : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
                    });
                    activeObject.setPositionByOrigin(new fabric.Point(objectLeft + objectWidth / 2 - activeObjectWidth / 2, activeObjectTop), 'center', 'center');
                }

                // snap by the vertical center line
                if (isInRange(objectTop, activeObjectTop)) {
                    horizontalInTheRange = true;
                    horizontalLines.push({
                        y: objectTop,
                        x1: (objectLeft < activeObjectLeft)
                            ? (objectLeft - objectWidth / 2 - aligningLineOffset)
                            : (objectLeft + objectWidth / 2 + aligningLineOffset),
                        x2: (activeObjectLeft > objectLeft)
                            ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
                            : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
                    });
                    activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop), 'center', 'center');
                }

                // snap by the top edge
                if (isInRange(objectTop - objectHeight / 2, activeObjectTop - activeObjectHeight / 2)) {
                    horizontalInTheRange = true;
                    horizontalLines.push({
                        y: objectTop - objectHeight / 2,
                        x1: (objectLeft < activeObjectLeft)
                            ? (objectLeft - objectWidth / 2 - aligningLineOffset)
                            : (objectLeft + objectWidth / 2 + aligningLineOffset),
                        x2: (activeObjectLeft > objectLeft)
                            ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
                            : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
                    });
                    activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop - objectHeight / 2 + activeObjectHeight / 2), 'center', 'center');
                }

                // snap by the bottom edge
                if (isInRange(objectTop + objectHeight / 2, activeObjectTop + activeObjectHeight / 2)) {
                    horizontalInTheRange = true;
                    horizontalLines.push({
                        y: objectTop + objectHeight / 2,
                        x1: (objectLeft < activeObjectLeft)
                            ? (objectLeft - objectWidth / 2 - aligningLineOffset)
                            : (objectLeft + objectWidth / 2 + aligningLineOffset),
                        x2: (activeObjectLeft > objectLeft)
                            ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
                            : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
                    });
                    activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop + objectHeight / 2 - activeObjectHeight / 2), 'center', 'center');
                }
            }

            if (!horizontalInTheRange) {
                horizontalLines.length = 0;
            }

            if (!verticalInTheRange) {
                verticalLines.length = 0;
            }
        }

        function guide2(e) {
            var activeObject = e.transform.target,
                canvasObjects = canvas.getObjects(),
                activeObjectCenter = activeObject.getCenterPoint(),
                activeObjectLeft = activeObjectCenter.x,
                activeObjectTop = activeObjectCenter.y,
                activeObjectBoundingRect = activeObject.getBoundingRect(),
                activeObjectHeight = activeObjectBoundingRect.height / viewportTransform[3],
                activeObjectWidth = activeObjectBoundingRect.width / viewportTransform[0],
                horizontalInTheRange = false,
                verticalInTheRange = false,
                transform = canvas._currentTransform;

            if (!transform) return;

            // It should be trivial to DRY this up by encapsulating (repeating) creation of x1, x2, y1, and y2 into functions,
            // but we're not doing it here for perf. reasons -- as this a function that's invoked on every mouse move

            for (var i = canvasObjects.length; i--;) {

                if (canvasObjects[i] === activeObject) continue;

                var objectCenter = canvasObjects[i].getCenterPoint(),
                    objectLeft = objectCenter.x,
                    objectTop = objectCenter.y,
                    objectBoundingRect = canvasObjects[i].getBoundingRect(),
                    objectHeight = objectBoundingRect.height / viewportTransform[3],
                    objectWidth = objectBoundingRect.width / viewportTransform[0];

                // snap by the horizontal center line
                if (isInRange(objectLeft, activeObjectLeft)) {
                    verticalInTheRange = true;
                    verticalLines.push({
                        x: objectLeft,
                        y1: (objectTop < activeObjectTop)
                            ? (objectTop - objectHeight / 2 - aligningLineOffset)
                            : (objectTop + objectHeight / 2 + aligningLineOffset),
                        y2: (activeObjectTop > objectTop)
                            ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
                            : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
                    });
                    // activeObject.setPositionByOrigin(new fabric.Point(objectLeft, activeObjectTop), 'center', 'center');
                }

                // snap by the left edge
                if (isInRange(objectLeft - objectWidth / 2, activeObjectLeft - activeObjectWidth / 2)) {
                    verticalInTheRange = true;
                    verticalLines.push({
                        x: objectLeft - objectWidth / 2,
                        y1: (objectTop < activeObjectTop)
                            ? (objectTop - objectHeight / 2 - aligningLineOffset)
                            : (objectTop + objectHeight / 2 + aligningLineOffset),
                        y2: (activeObjectTop > objectTop)
                            ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
                            : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
                    });
                    // activeObject.scaleToWidth(objectWidth-activeObjectWidth);
                }

                // snap by the right edge
                if (isInRange(objectLeft + objectWidth / 2, activeObjectLeft + activeObjectWidth / 2)) {
                    verticalInTheRange = true;
                    verticalLines.push({
                        x: objectLeft + objectWidth / 2,
                        y1: (objectTop < activeObjectTop)
                            ? (objectTop - objectHeight / 2 - aligningLineOffset)
                            : (objectTop + objectHeight / 2 + aligningLineOffset),
                        y2: (activeObjectTop > objectTop)
                            ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
                            : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
                    });
                    // activeObject.setPositionByOrigin(new fabric.Point(objectLeft + objectWidth / 2 - activeObjectWidth / 2, activeObjectTop), 'center', 'center');
                }

                // snap by the vertical center line
                if (isInRange(objectTop, activeObjectTop)) {
                    horizontalInTheRange = true;
                    horizontalLines.push({
                        y: objectTop,
                        x1: (objectLeft < activeObjectLeft)
                            ? (objectLeft - objectWidth / 2 - aligningLineOffset)
                            : (objectLeft + objectWidth / 2 + aligningLineOffset),
                        x2: (activeObjectLeft > objectLeft)
                            ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
                            : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
                    });
                    // activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop), 'center', 'center');
                }

                // snap by the top edge
                if (isInRange(objectTop - objectHeight / 2, activeObjectTop - activeObjectHeight / 2)) {
                    horizontalInTheRange = true;
                    horizontalLines.push({
                        y: objectTop - objectHeight / 2,
                        x1: (objectLeft < activeObjectLeft)
                            ? (objectLeft - objectWidth / 2 - aligningLineOffset)
                            : (objectLeft + objectWidth / 2 + aligningLineOffset),
                        x2: (activeObjectLeft > objectLeft)
                            ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
                            : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
                    });
                    // activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop - objectHeight / 2 + activeObjectHeight / 2), 'center', 'center');
                }

                // snap by the bottom edge
                if (isInRange(objectTop + objectHeight / 2, activeObjectTop + activeObjectHeight / 2)) {
                    horizontalInTheRange = true;
                    horizontalLines.push({
                        y: objectTop + objectHeight / 2,
                        x1: (objectLeft < activeObjectLeft)
                            ? (objectLeft - objectWidth / 2 - aligningLineOffset)
                            : (objectLeft + objectWidth / 2 + aligningLineOffset),
                        x2: (activeObjectLeft > objectLeft)
                            ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
                            : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
                    });
                    // activeObject.set('width', objectWidth / canvasObjects[i].scaleX);
                }
            }

            if (!horizontalInTheRange) {
                horizontalLines.length = 0;
            }

            if (!verticalInTheRange) {
                verticalLines.length = 0;
            }
        }

        canvas.on('object:moving', function (e) {
            canvas.clearContext(ctx);
            guide(e);
        });

        canvas.on('object:scaling', function (e) {
            canvas.clearContext(ctx);
            guide2(e);
        });

        canvas.on('before:render', function () {
            // canvas.clearContext(ctx);
        });

        canvas.on('after:render', function () {
            for (var i = verticalLines.length; i--;) {
                drawVerticalLine(verticalLines[i]);
            }
            for (var i = horizontalLines.length; i--;) {
                drawHorizontalLine(horizontalLines[i]);
            }

            verticalLines.length = horizontalLines.length = 0;
        });

        canvas.on('mouse:up', function () {
            verticalLines.length = horizontalLines.length = 0;
            canvas.clearContext(ctx);
            canvas.renderAll();
        });
    }

    function alFabricUseMainImage(callBack = function () { }) {
        let objects = alFabricGetImageObjects();

        if (objects.length === 0) {
            callBack();
            return;
        }

        let counter = 0;
        fixOne();

        function fixOne() {
            if (counter === objects.length) {
                callBack();
                return;
            }

            let id = al.fabric.mainCanvas._objects.indexOf(objects[counter]);

            alImageFit(id, true, function () {
                counter++;
                fixOne();
            });
        }
    }

    function alPagePreparing() {
        alLayoutGetData();
        for (let i = 0; i < parseInt(al.form.pageCount); i++)
            alPageAdd();
        alPageChange(0, function () { }, null, true);
    }

    function alPageChange(pageNumber, callBackFuntion = function () { }, save = true, showThumb = false) {
        al.cur.working = true;

        $("#ablumNextPrev").hide();
        $("#ablumBackPrev").hide();

        if (save) alPageSave();

        if (pageNumber === "next") {
            if (al.cur.page + 1 <= al.page.list.length - 1) {
                pageNumber = al.cur.page + 1;
            }
            else {
                return;
            }

        }
        else if (pageNumber === "prev") {
            if (al.cur.page - 1 >= 0) {
                pageNumber = al.cur.page - 1;
            }
            else {
                return;
            }
        }
        al.cur.page = pageNumber;

        if (showThumb) {
            alLoadingShow();

            if (al.cur.page + 1 <= al.page.list.length - 1) {
                alFabricCleanCanvas();

                al.cur.pageState = al.page.list[pageNumber + 1].state;
                al.image.fabricImages = al.page.list[al.cur.page + 1].images.slice();

                let pageObjects = al.page.list[pageNumber + 1].objects;
                let counter = 0;
                fit();
                function fit() {
                    if (counter >= pageObjects.length) {
                        setNext();
                        return;
                    }

                    al.fabric.mainCanvas.add(pageObjects[counter]);

                    alImageFit(counter, false, function () {
                        counter++;
                        fit();
                    });
                }

                function setNext() {
                    let singleImg = new Image();
                    singleImg.src = al.fabric.mainCanvas.toDataURL();
                    singleImg.onload = function () {
                        $("#ablumNextPrev").attr("src", singleImg.src);
                    }
                    $("#ablumNextPrev").show();
                    startBack();
                }
            }
            else {
                startBack();
            }

            function startBack() {
                if (al.cur.page - 1 >= 0) {
                    alFabricCleanCanvas();

                    al.cur.pageState = al.page.list[pageNumber - 1].state;
                    al.image.fabricImages = al.page.list[al.cur.page - 1].images.slice();

                    let pageObjects = al.page.list[pageNumber - 1].objects;
                    let counter = 0;
                    fit();
                    function fit() {
                        if (counter >= pageObjects.length) {
                            setBack();
                            return;
                        }

                        al.fabric.mainCanvas.add(pageObjects[counter]);

                        alImageFit(counter, false, function () {
                            counter++;
                            fit();
                        });
                    }

                    function setBack() {
                        let singleImg = new Image();
                        singleImg.src = al.fabric.mainCanvas.toDataURL();
                        singleImg.onload = function () {
                            $("#ablumBackPrev").attr("src", singleImg.src);
                        }
                        $("#ablumBackPrev").show();
                        alLoadingHide();
                        resume0();
                    }
                }
                else {
                    alLoadingHide();
                    resume0();
                }
            }
        }
        else {
            resume0();
        }

        function resume0() {
            alFabricCleanCanvas();

            al.cur.pageState = al.page.list[al.cur.page].state;
            al.image.fabricImages = al.page.list[al.cur.page].images.slice();

            if (al.cur.page === parseInt(al.form.pageCount) - 1)
                $(".albumExtra").show();
            else
                $(".albumExtra").hide();

            $(".albumCanvasHeaderPageNum").html(pageNumber + 1);
            $(".albumDesignPageNum").html(pageNumber + 1);

            let pageObjects = al.page.list[pageNumber].objects;
            let counter = 0;
            fit();
            function fit() {
                if (counter >= pageObjects.length) {
                    resume();
                    return;
                }

                al.fabric.mainCanvas.add(pageObjects[counter]);

                alImageFit(counter, false, function () {
                    counter++;
                    fit();
                });
            }
        }

        function resume() {
            let back = al.page.list[pageNumber].background;
            if (typeof (back) === "string") {
                alBackgroundChange("color", back, function () {
                    resume2();
                });
            }
            else {
                alBackgroundChange("image", back, function () {
                    resume2();
                });
            }
        }

        function resume2() {
            alPageUpdateNav();
            alLayoutListUpdate();
            alPageImageListUpdate();
            alFabricMoveSync();
            callBackFuntion();
        }
    }

    function alPageSave() {
        al.page.list[al.cur.page].objects = al.fabric.mainCanvas._objects.slice();
        al.page.list[al.cur.page].state = al.cur.pageState.slice();
        let imageList = alFabricGetImageObjects();
        al.page.list[al.cur.page].imageCount = imageList.length;
        al.page.list[al.cur.page].images = al.image.fabricImages.slice();
    }

    function alPageAdd(callBack = function () { }) {
        al.cur.working = true;

        if (al.page.list.length >= al.form.pageCount) {
            if (confirm("Oh oh! \n Looks like you’re out of spreads! \n Purchase another spread? \n +$10.00")) {
                al.form.pageCount = parseInt(al.form.pageCount) + 1;
                al.cur.totalPrice = parseInt(al.cur.totalPrice) + 10;
                alFinishShow();
            }
            else
                return;
        }
        al.page.list.push(
            {
                objects: [],
                state: [],
                images: [],
                imageCount: 0,
                background: "#ffffff",
                layoutId: -1
            }
        );

        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");
        alPageChange(al.page.list.length - 1, function () {
            alLoadingHide();
            callBack();
        }, null, true);
    }

    function alPageUpdateNav() {
        $(".albumCanvasPageNext").hide();
        $(".albumCanvasPagePrev").hide();

        if (al.cur.page + 1 <= al.page.list.length - 1) {
            $(".albumCanvasPageNext").show();
        }
        if (al.cur.page - 1 >= 0) {
            $(".albumCanvasPagePrev").show();
        }
    }

    function alImageFit(clipId, useMainPic = false, callback = function () { }) {
        al.cur.working = true;

        if (al.fabric.mainCanvas._objects[clipId].type !== "rect") {
            callback();
            return;
        }

        let imageSrc = al.image.list[al.image.fabricImages[clipId].id].thumbSrc;
        if (useMainPic)
            imageSrc = al.image.list[al.image.fabricImages[clipId].id].src;


        fabric.Image.fromURL(imageSrc, function (img) {

            let clip = al.fabric.mainCanvas._objects[clipId];

            let clipWidth = clip.width * al.cur.pageState[clipId].scale;
            let clipHeight = clip.height * al.cur.pageState[clipId].scale;
            let clipRatio = clipWidth / clipHeight;

            let imgWidth = img.width;
            let imgHeight = img.height;
            let imgRatio = imgWidth / imgHeight;

            let offsetX = 0;
            let offsetY = 0;

            let movedX = al.image.fabricImages[clipId].movedX;
            let movedY = al.image.fabricImages[clipId].movedY;

            let left = 0;
            let top = 0;

            if (imgRatio <= clipRatio) {
                img.scaleToWidth(clipWidth);
                offsetX = - (clipWidth - clip.width) / 2;
                offsetY = - (((imgHeight * (clipWidth / imgWidth)) - clipHeight) / 2) - (clipHeight - clip.height) / 2;
            }
            else {
                img.scaleToHeight(clipHeight);
                offsetX = - (((imgWidth * (clipHeight / imgHeight)) - clipWidth) / 2) - (clipWidth - clip.width) / 2;
                offsetY = - (clipHeight - clip.height) / 2;
            }

            left = offsetX + movedX;
            if (left > 0)
                left = 0;
            else if ((- left) + clip.width > img.getScaledWidth())
                left = clip.width - img.getScaledWidth();

            top = offsetY + movedY;
            if (top > 0)
                top = 0;
            else if ((- top) + clip.height > img.getScaledHeight())
                top = clip.height - img.getScaledHeight();

            let patternSourceCanvas = new fabric.StaticCanvas();
            patternSourceCanvas.add(img);
            patternSourceCanvas.setDimensions({
                width: img.getScaledWidth(),
                height: img.getScaledHeight(),
            });

            let filters = al.image.list[al.image.fabricImages[clipId].id].filters.slice();
            if (filters.length > 0) {
                fixfilters = [];
                $.each(filters, function (i, item) {
                    if (item !== null && item !== undefined) {
                        fixfilters[i] = new fabric.Image.filters[item.type]({
                            [item.type.toLowerCase()]: item[item.type.toLowerCase()]
                        });
                    }
                });
                patternSourceCanvas._objects[0].filters = fixfilters;
                patternSourceCanvas._objects[0].applyFilters();
            }

            patternSourceCanvas.renderAll();

            let pattern = new fabric.Pattern({
                source: patternSourceCanvas.getElement(),
                repeat: 'no-repeat',
                offsetX: left,
                offsetY: top
            });

            clip.set('fill', pattern);

            al.image.fabricImages[clipId].offsetX = offsetX;
            al.image.fabricImages[clipId].offsetY = offsetY;

            patternSourceCanvas.renderAll();
            al.fabric.mainCanvas.renderAll();

            callback();
        });
    }

    function alImagePreventOverflow(options) {
        al.cur.working = true;

        if (!options.target) return;

        let image = options.target;

        let tgHeight = image.height * image.scaleY;
        let tgWidth = image.width * image.scaleX;
        let tgTop = image.top;
        let tgLeft = image.left;
        let tgBottom = tgHeight + tgTop;
        let tgRight = tgWidth + tgLeft;

        let ClipHeight = image.clipPath.height;
        let ClipWidth = image.clipPath.width;
        let ClipTop = image.clipPath.top;
        let ClipLeft = image.clipPath.left;
        let ClipBottom = ClipHeight + ClipTop;
        let ClipRight = ClipWidth + ClipLeft;

        if (tgLeft > ClipLeft) {
            image.left = ClipLeft;
        }
        if (tgTop > ClipTop) {
            image.top = ClipTop;
        }
        if (tgRight < ClipRight) {
            image.left = ClipRight - tgWidth;
        }
        if (tgBottom < ClipBottom) {
            image.top = ClipBottom - tgHeight;
        }
    }

    function alPageImageListUpdate() {
        $(".albumPageImages").hide();
        $(".albumPageImages").html("");
        return;
        let objects = alFabricGetImageObjects();

        if (objects.length === 0)
            return;

        $(".albumPageImages").show();

        for (let i = 0; i < objects.length; i++) {
            $(".albumPageImages").append(
                "<div>" +
                "<img " +
                "src='" + $(objects[i]._originalElement).attr("src") + "' " +
                ">" +
                "</div>"
            );
        }
    }

    function alLayoutListUpdate() {
        let page = al.page.list[al.cur.page];

        $(".albumLayoutList").html("");
        $(".albumLayoutList").hide();

        if (page.imageCount === 0)
            return;

        let layoutList = al.layout.list.filter(item => item.count === page.imageCount);

        for (let i = 0; i < layoutList.length; i++) {
            // let activeClass = "";
            // if(layoutList[i].id === page.layoutId)
            //     activeClass = "albumLayoutListActive";

            $(".albumLayoutList").append("" +
                "<img " +
                "src='" + layoutList[i].src + "' " +
                "id='" + layoutList[i].id + "' " +
                "alt='layout' " +
                // "class='" + activeClass + "' " +
                ">");
        }
    }

    function alLayoutChange(layout) {
        al.cur.working = true;

        let id = parseInt($(layout).attr("id"));

        if (!id) {
            console.log("Layout change error: Can't find layout");
            return;
        }

        layout = al.layout.list.filter(item => item.id === id);
        layout = layout[0];
        let objects = al.page.list[al.cur.page].objects;
        al.page.list[al.cur.page].layoutId = layout.id;

        for (let i = 0; i < objects.length; i++) {
            if (objects[i].isType("rect"))
                alFabricChangeDimention(i, layout.clips[i])
        }

        alPageSave();
    }

    function alBackgroundChange(type, value, callBackFunction = function () { }) {
        al.cur.working = true;

        if (value === -1) {
            type = "color";
            value = "#ffffff";
        }
        if (type === "color") {
            al.page.list[al.cur.page].background = value;
            al.fabric.mainCanvas.setBackgroundColor(value, function () {
                callBackFunction();
                al.fabric.mainCanvas.renderAll();
            });
            $(".albumFooterBackList").find(".albumFooterBackListActive").removeClass("albumFooterBackListActive");
            $("#albumFooterOptBack").val(value);
        }
        else if (type === "image") {
            let backImg = value;
            if (!isNaN(value))
                backImg = al.back.list[value - 1];

            al.page.list[al.cur.page].background = backImg;

            fabric.util.loadImage(backImg.src, function (img) {
                let pattern = new fabric.Pattern({ source: img });

                al.fabric.mainCanvas.setBackgroundColor(pattern, function () {
                    al.fabric.mainCanvas.renderAll();
                    callBackFunction();
                });
            });

            $(".albumFooterBackList").find(".albumFooterBackListActive").removeClass("albumFooterBackListActive");
            $(".albumFooterBackList").find("#" + backImg.id).addClass("albumFooterBackListActive");

            $("#albumFooterOptBack").val("#ffffff");
        }

    }

    function alBackgroundUpdateList() {
        for (let i = 0; i < al.back.list.length; i++) {
            $(".albumFooterBackList").append(
                "<div " +
                "id = '" + al.back.list[i].id + "'" +
                ">" +
                "<img " +
                "src='" + al.back.list[i].src + "' " +
                ">" +
                "</div>"
            );
        }
    }

    function alBackgroundToggleList() {
        al.cur.working = true;

        $(".albumFooterBackList").toggle();
    }

    function alGenerateLayout(list = false, oList = false) {
        al.cur.working = true;

        $(".albumCanvas").show();
        $(".albumDropBox").hide();
        $(".albumHeaderPreview").show();

        if (!list)
            list = $(".albumFooterImagesList").children(".ui-selected");

        al.generate.list = list;
        let imgCount = list.length;

        if (imgCount === 0) {
            alert("Please Select Images First");
            return;
        }

        if (imgCount > 8) {
            alert("The number of images is more than 8.");
            return;
        }

        if (
            al.page.list[al.cur.page].imageCount > 0
            && parseInt(al.form.pageCount) === (al.cur.page + 1)
        ) {
            alPageAdd(function () {
                resume();
            });
        }
        else if (al.page.list[al.cur.page].imageCount > 0) {
            alPageChange(al.cur.page + 1, function () {
                alGenerateLayout(list, oList);
            }, null, true);
        }
        else
            resume();

        function resume() {


            ratioList = [];
            for (let i = 0; i < list.length; i++) {
                let imgId = al.image.list.findIndex(item => item.id === parseInt($(list[i]).attr("id").replace("image", "")));
                ratioList.push(al.image.list[imgId].ratio);
            }
            alFindeBestLayout(ratioList, al.fabric.mainCanvas.width, al.fabric.mainCanvas.height, 7 , 20, 20, function (layouts) {
                resume2(layouts);
            });

            function resume2(layouts) {
                $(".generatePopUpList").html("");

                al.generate.layout = layouts;
                console.log(layouts);

                $.each(layouts,function(index,item){
                    if(item.coverage >= 0.28 || item.type === "one")
                    {
                        $(".generatePopUpList").append("<img src='" + item.src + "' id='" + item.id + "'>");
                    }
                });

                // $(".generatePopUp").css("display","flex");
                $(".generatePopUp").slideDown().css("display","flex");
            }
        }
    }

    function alGenerateLayoutPopUpClose() {
        $(".generatePopUp").slideUp();
    }

    function alGenerateLayoutFin(elm) {
        var id = parseInt($(elm).attr("id"));

        var layout = al.generate.layout.filter(item => item.id === id)[0];
        var list = al.generate.list;
        var imgCount = al.generate.list.length;

        for (let i = 0; i < imgCount; i++) {
            var clipPath = {
                top: layout.rects[i][0],
                left: layout.rects[i][1],
                width: layout.rects[i][2],
                height: layout.rects[i][3],
                ratio: layout.rects[i][4]
            };

            if(layout.type === "col")
                clipPath.ratio = 1 / clipPath.ratio;

            for (let j = 0; j < list.length; j++) {
                let imgId = al.image.list.findIndex(item => item.id === parseInt($(list[j]).attr("id").replace("image", "")));

                if (al.image.list[imgId].ratio === clipPath.ratio) {
                    alFabricAdd($(list[j]), clipPath);
                    list.splice(j, 1);
                    break;
                }
            }
        }

        al.fabric.mainCanvas.renderAll();

        alPageSave();
        alLayoutListUpdate();
        alPageImageListUpdate();
        alImageListUpdate();

        alGenerateLayoutPopUpClose();
    }

    function alPreviewShow() {
        al.cur.working = true;

        if (al.fabric.mainCanvas === "")
            return;

        alPageSave();

        //check for complete
        if (al.page.list.length < al.form.pageCount) {
            alert("Please Complete all " + al.form.pageCount + " spreads.");
            return;
        }

        //check for empty
        // let emptySpread = "";
        // for(let i = 0; i < al.page.list.length; i++)
        // {
        //     if(al.page.list[i].imageCount === 0)
        //     {
        //         emptySpread += (i+1) + "-";
        //     }
        // }
        // if(emptySpread !== "")
        // {
        //     alert("These spreads are blank : " + emptySpread);
        //     return;
        // }

        //layout list
        $(".albumPreviewList").html("");

        // for(let i = 0; i < al.page.list.length; i++)
        // {
        //     let src = al.layout.list[al.page.list[i].layoutId - 1].src;
        //     $(".albumPreviewList").append("<img src='" + src + "' id='" + i + "'>");
        // }

        alLoadingShow("Proccing to preview ...");
        let counter = 0;
        setList(counter);
        function setList(i) {
            if (i >= al.page.list.length) {
                alPreviewShowSingle($(".albumPreviewList").children().first());
                return;
            }

            alLoadingShow("Proccing to preview : " + (i + 1) + "/" + al.page.list.length);

            alPageChange(i, function () {
                resume();
            });

            function resume() {
                let Img = new Image();
                Img.src = al.fabric.mainCanvas.toDataURL();
                Img.onload = function () {
                    $(".albumPreviewList").append("<img src='" + Img.src + "' id='" + i + "'>");
                    counter++;
                    setList(counter);
                }
            }
        }

        // alPreviewShowSingle($(".albumPreviewList").children().first());

        //desc
        let size = al.form.size.split("-");
        let ori = al.form.ori;
        let desc = ori.charAt(0).toUpperCase() + ori.slice(1) + " Photo Book | " + size[0] + " inch × " + size[1] + " inch |" +
            " " + al.form.pageCount + " Spreads (" + (al.form.pageCount * 2) + " Pages)";
        $(".albumPreviewDesc").html(desc);

        //total price
        $(".albumPreviewTotalPrice").html("$" + al.cur.totalPrice);

        //show hide
        $(".albumWorkArea").hide();
        $(".albumPreview").show();
        $("#albumProof").addClass("albumHeaderProgressItemActive");
    }

    function alPreviewShowSingle(element) {
        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");
        $(".albumPreviewList").find(".albumPreviewListActive").removeClass("albumPreviewListActive");
        $(element).addClass("albumPreviewListActive");

        let id = parseInt($(element).attr("id"));

        alPageChange(id, function () {
            resume();
        })

        function resume() {
            let singleImg = new Image();
            singleImg.src = al.fabric.mainCanvas.toDataURL();
            singleImg.onload = function () {
                $("#albumPreviewSingle").attr("src", singleImg.src);
                alLoadingHide();
            }
        }
    }

    function alPreviewMakeChange() {
        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");
        alPageChange(parseInt($(".albumPreviewList").find(".albumPreviewListActive").attr("id")), function () {
            alLoadingHide();
        }, null, true);

        $(".albumWorkArea").show();
        $(".albumPreview").hide();
        $("#albumProof").removeClass("albumHeaderProgressItemActive");
    }

    function alDesignMenuSync() {
        let activeObj = al.fabric.mainCanvas.getActiveObject();
        if (activeObj) {
            $(".albumCanvasHeader").hide();
            $(".albumDesign").show();
        }
        else {
            $(".albumCanvasHeader").show();
            $(".albumDesign").hide();
        }
        alTextOptSync();
    }

    function alDesignZoomBtn() {
        if ($(".albumDesignZoom").hasClass("albumDesignZoomActive")) {
            $(".albumDesignZoom").removeClass("albumDesignZoomActive");
            $(".albumDesignZoomInput").hide();
            return;
        }
        $(".albumDesignZoom").addClass("albumDesignZoomActive");
        $(".albumDesignZoomInput").show();
    }

    function alDesignZoomChange(value = null) {
        al.cur.working = true;

        let imageObj = al.fabric.mainCanvas.getActiveObject();
        let imageIndex = al.fabric.mainCanvas._objects.indexOf(imageObj);

        if (imageObj === null || !imageObj.isType("rect")) {
            alert("No Image Selected.")
            $(".albumDesignZoomInputSlider").val(0);
            $(".albumDesignZoomInputSliderPercent").html("0%");
            return;
        }

        let defualtScale = 1;

        let val;
        if (value === null)
            val = $(".albumDesignZoomInputSlider").val();
        else {
            val = value;
            $(".albumDesignZoomInputSlider").val(value)
        }

        $(".albumDesignZoomInputSliderPercent").html(Math.round((val * 100)) + "%");

        let zoomRatio = val * al.default.zoomMax + 1;

        al.cur.pageState[imageIndex].scale = zoomRatio;

        alFabricMoveSync();
        alImageFit(imageIndex);

        // let tgHeight = imageObj.height * imageObj.scaleY;
        // let tgWidth = imageObj.width * imageObj.scaleX;
        // let tgTop = imageObj.top;
        // let tgLeft = imageObj.left;
        // let tgBottom = tgHeight + tgTop;
        // let tgRight = tgWidth + tgLeft;
        //
        // let ClipHeight = imageObj.clipPath.height;
        // let ClipWidth = imageObj.clipPath.width;
        // let ClipTop = imageObj.clipPath.top;
        // let ClipLeft = imageObj.clipPath.left;
        // let ClipBottom = ClipHeight + ClipTop;
        // let ClipRight = ClipWidth + ClipLeft;
        //
        // if(tgLeft>0)
        // {
        //     imageObj.left = ClipLeft;
        // }
        // if(tgTop>0){
        //     imageObj.top = ClipTop;
        // }
        // if(tgRight < ClipRight)
        // {
        //     imageObj.left = ClipRight-tgWidth;
        // }
        // if(tgBottom < ClipBottom)
        // {
        //     imageObj.top = ClipBottom - tgHeight;
        // }
        //
        // al.fabric.mainCanvas.renderAll();
    }

    function alDesignZoomSync(option) {
        al.cur.working = true;

        let imageObj = option.target;

        if (imageObj === null) {
            $(".albumDesignZoomInputSlider").val(0);
            $(".albumDesignZoomInputSliderPercent").html("0%");
            return;
        }

        if (!imageObj.isType("rect")) {
            $(".albumDesignZoomInputSlider").val(0);
            $(".albumDesignZoomInputSliderPercent").html("0%");
            return;
        }

        let imageIndex = al.fabric.mainCanvas._objects.indexOf(imageObj);

        let val = al.cur.pageState[imageIndex].scale - 1;

        $(".albumDesignZoomInputSlider").val(val);
        $(".albumDesignZoomInputSliderPercent").html(Math.round((val * 100)) + "%");

    }

    function alDesignAdjustBtn() {
        if ($(".albumDesignAdjust").hasClass("albumDesignAdjustActive")) {
            $(".albumDesignAdjust").removeClass("albumDesignAdjustActive");
            $(".albumAdjust").hide();
            return;
        }
        $(".albumDesignAdjust").addClass("albumDesignAdjustActive");
        $(".albumAdjust").show();
        alAdjustSync();
    }

    function alAdjustCheckSize(callBack) {
        let object = al.fabric.adjustCanvas._objects[0];
        if (object === null || object === undefined)
            return;

        if (Math.max(object.width, object.height) > 2048) {
            alLoadingShow("Processing...<br> Please wait . It take a few minutes.");

            // let objectIndex = al.fabric.adjustCanvas._objects.indexOf(object);
            //
            // let ZoomPrev = ( object.scaleX / al.cur.pageState[objectIndex].scale ) - 1;
            // let TopPrev = object.top;
            // let LeftPrev = object.left;

            let scale = 2048 / Math.max(object.width, object.height);

            let resizeImg = new Image();
            resizeImg.crossOrigin = 'anonymous';
            resizeImg.src = $(object._originalElement).attr("src");
            resizeImg.onload = function () {

                let width = resizeImg.width *= scale;
                let height = resizeImg.height *= scale;

                let resizeCanvas = document.createElement("canvas");
                resizeCanvas.width = width;
                resizeCanvas.height = height;
                let resizeCanvasCtx = resizeCanvas.getContext("2d");
                resizeCanvasCtx.drawImage(resizeImg, 0, 0, width, height);
                resizeImg.src = resizeCanvas.toDataURL('image/jpeg');

                resizeImg.onload = function () {
                    alAdjustAdd(resizeImg);
                    callBack();
                    alLoadingHide();
                }
            }
        }
        else
            callBack();
    }

    function alAdjustRangeChange(input) {
        let val = $(input).val();

        $(input).parent().find(".albumAdjustRangeCount").html(Math.round(val * 100));

        alAdjustCheckSize(function () {
            let type = $(input).attr("id");
            let index = $(input).attr("data-index");
            let obj = al.fabric.adjustCanvas._objects[0];

            obj.filters[index] = new fabric.Image.filters[type]({
                [type.toLowerCase()]: val
            });

            obj.applyFilters();
            al.fabric.adjustCanvas.renderAll();
        });
    }

    function alAdjustSync(option = null) {
        al.cur.working = true;

        if ($(".albumAdjust").is(":hidden"))
            return;

        let clipObj = "";
        if (option === null)
            clipObj = al.fabric.mainCanvas.getActiveObject();
        else
            clipObj = option.target;

        if (clipObj === null || clipObj === undefined || !clipObj.isType("rect")) {
            alAdjustClean();
            alAdjustReset();
            return;
        }

        let clipIndex = al.fabric.mainCanvas._objects.indexOf(clipObj);
        let id = al.image.fabricImages[clipIndex].id;

        if (al.cur.adjustImage === id)
            return;

        let imgElement = new Image();
        imgElement.crossOrigin = 'anonymous';
        imgElement.src = al.image.list[id].thumbSrc;
        imgElement.onload = function () {

            al.cur.adjustImage = id;

            alAdjustAdd(imgElement);
            alAdjustRestore(al.image.list[parseInt(id)].filters.slice());
        }
    }

    function alAdjustRestore(filters) {
        let list = $(".albumAdjustRanges").find(".albumAdjustSlider").toArray();

        for (let i = 0; i < list.length; i++) {
            let type = $(list[i]).attr("id");
            let index = $(list[i]).attr("data-index");
            let val = 0;
            if (filters[index] !== undefined)
                val = filters[index][type.toLowerCase()];
            $(list[i]).val(val);
            $(list[i]).parent().find(".albumAdjustRangeCount").html(Math.round(val * 100));
            alAdjustRangeChange($(list[i]));
        }
    }

    function alAdjustClean() {
        al.cur.adjustImage = "";
        let adjustImage = al.fabric.adjustCanvas._objects[0];
        if (adjustImage)
            al.fabric.adjustCanvas.remove(adjustImage);
    }

    function alAdjustAdd(imgElement) {
        alAdjustClean();

        let imgInstance = new fabric.Image(imgElement, {
            left: 0,
            top: 0,
            opacity: 1,
            hasBorders: false,
            hasRotatingPoint: false,
            transparentCorners: false,
            hasControls: false,
            centeredRotation: true,
            selectable: false
        });
        al.fabric.adjustCanvas.add(imgInstance);

        alAdjustFitImage();
        al.fabric.mainCanvas.renderAll();
    }

    function alAdjustFitImage() {
        al.cur.working = true;

        let image = al.fabric.adjustCanvas._objects[0];

        let imgWidth = image.width;
        let imgHeight = image.height;
        let imgRatio = imgWidth / imgHeight;
        let trgWidth = al.fabric.adjustCanvas.width;
        let trgHeight = al.fabric.adjustCanvas.height;
        let trgRatio = trgWidth / trgHeight;

        if (imgRatio <= trgRatio) {
            image.scaleToHeight(trgHeight, true);
            image.left = image.left - (((imgWidth * (trgHeight / imgHeight)) - trgWidth) / 2);
        }
        else {
            image.scaleToWidth(trgWidth, true);
            image.top = image.top - (((imgHeight * (trgWidth / imgWidth)) - trgHeight) / 2);
        }
    }

    function alAdjustReset(apply) {
        al.cur.working = true;

        let list = $(".albumAdjustRanges").find(".albumAdjustSlider").toArray();

        for (let i = 0; i < list.length; i++) {
            $(list[i]).val(0);
            $(list[i]).parent().find(".albumAdjustRangeCount").html("0");

            if (apply)
                alAdjustRangeChange($(list[i]));
        }
    }

    function alAdjustCheckTargetSize(callBack) {
        let clip = al.fabric.mainCanvas.getActiveObject();
        let clipIndex = al.fabric.mainCanvas._objects.indexOf(clip);

        let image = al.image.list[al.image.fabricImages[clipIndex].id].thumbSrc;

        if (clip === null)
            return;

        if (Math.max(image.naturalWidth, image.naturalHeight) > 2048) {
            alLoadingShow("Processing...<br> Please wait . It take a few minutes.");

            let ZoomPrev = (clip.scaleX / al.cur.pageState[clipIndex].scale) - 1;
            let TopPrev = clip.top;
            let LeftPrev = clip.left;

            let scale = 2048 / Math.max(image.naturalWidth, image.naturalHeight);

            let resizeImg = new Image();
            resizeImg.crossOrigin = 'anonymous';
            resizeImg.src = $(image).attr("src");
            resizeImg.onload = function () {

                let width = resizeImg.width *= scale;
                let height = resizeImg.height *= scale;

                let resizeCanvas = document.createElement("canvas");
                resizeCanvas.width = width;
                resizeCanvas.height = height;
                let resizeCanvasCtx = resizeCanvas.getContext("2d");
                resizeCanvasCtx.drawImage(resizeImg, 0, 0, width, height);
                resizeImg.src = resizeCanvas.toDataURL('image/jpeg');

                resizeImg.onload = function () {
                    $(image).attr("src", resizeImg.src);

                    let imageId = parseInt(al.image.fabricImages[clipIndex].id);
                    al.image.list[imageId].src = resizeImg.src;

                    alImageFit(clipIndex);

                    callBack(true);
                    alLoadingHide();
                }
            }
        }
        else
            callBack(false);
    }

    function alAdjustSave() {
        al.cur.working = true;

        let activeObj = al.fabric.mainCanvas.getActiveObject();
        if (activeObj === undefined)
            return;

        let adjustImage = al.fabric.adjustCanvas._objects[0];
        let filters = adjustImage.filters.slice();

        alAdjustCheckTargetSize(function (resize) {
            if (resize)
                activeObj = al.fabric.mainCanvas._objects[al.fabric.mainCanvas._objects.length - 1];

            let activeObjIndex = al.fabric.mainCanvas._objects.indexOf(activeObj);

            let imageIndex = parseInt(al.image.fabricImages[activeObjIndex].id);
            al.image.list[imageIndex].filters = filters.slice();

            alImageFit(activeObjIndex);
        });
    }

    function alTextBtn() {
        al.cur.working = true;

        let text = prompt("Please enter your text", "Sample Text");
        if (text === null)
            return;

        let textObject = new fabric.Textbox(text, {
            left: 100,
            top: 100,
            fill: "#000000",
            centeredRotation: true,
            objectCaching: false,
            cornerStyle: "circle",
            cornerSize: 8,
            borderColor: "#555555",
            cornerColor: "#4cc2ce",
            cornerStrokeColor: "#4cc2ce",
        });
        // textObject.setControlsVisibility({ 'mt': false, 'mb': false, 'ml': false, 'mr': false });

        al.fabric.mainCanvas.add(textObject);
        al.fabric.mainCanvas.renderAll();

        alPageSave();
    }

    function alTextOptSync() {
        let object = al.fabric.mainCanvas.getActiveObject();
        if (object === undefined || object === null) {
            $(".albumDesingTextOption").hide();
        }
        else if (object.type === "textbox") {
            $("#albumDesingTextOptionColor").val(object.fill);
            if (object.fontFamily === "Times New Roman") {
                $("#albumDesingTextOptionFont").val("Default");
            }
            else {
                $("#albumDesingTextOptionFont").val(object.fontFamily);
            }
            $(".albumDesingTextOption").show();
        }
        else {
            $(".albumDesingTextOption").hide();
        }
    }

    function alTextOptColor() {
        let object = al.fabric.mainCanvas.getActiveObject();
        object.fill = $("#albumDesingTextOptionColor").val();
        al.fabric.mainCanvas.renderAll();
    }

    function alTextOptFont() {
        let object = al.fabric.mainCanvas.getActiveObject();
        let font = $("#albumDesingTextOptionFont").val();

        if (font === "Default") {
            object.set("fontFamily", "");
            al.fabric.mainCanvas.requestRenderAll();
            return;
        }

        let myFont = new FontFaceObserver(font);
        alLoadingShow("Loading Font...");
        myFont.load()
            .then(function () {
                alLoadingHide();
                object.set("fontFamily", font);
                al.fabric.mainCanvas.requestRenderAll();
            }).catch(function (e) {
                console.log(e)
                alert('Font loading failed ' + font);
                $("#albumDesingTextOptionFont").val("Default");
                alLoadingHide();
            });
    }

    function alFinishBtn() {
        alLoadingShow("Processing...")
        if (!confirm("Do you really finish your design?")) {
            alPreviewShow();
            return;
        }

        if (al.fabric.mainCanvas === "")
            return;

        alPageSave();

        //check for complete
        if (al.page.list.length < al.form.pageCount) {
            alert("Please Complete all " + al.form.pageCount + " spreads.");
            return;
        }

        //check for empty
        // let emptySpread = "";
        // for(let i = 0; i < al.page.list.length; i++)
        // {
        //     if(al.page.list[i].imageCount === 0)
        //     {
        //         emptySpread += (i+1) + "-";
        //     }
        // }
        // if(emptySpread !== "")
        // {
        //     alert("These spreads are blank : " + emptySpread);
        //     return;
        // }

        //start upload

        let albumWidth = al.form.size.split("-");
        albumWidth = parseInt(albumWidth[0]) * 2 * al.default.dpi;
        let multiplier = albumWidth / al.fabric.mainCanvas.width;

        let dataList = [];
        let dataCounter = 0;

        addToList();

        function addToList() {
        
        	alLoadingShow("Processing...<br> " + Math.round((dataCounter/al.page.list.length)*100) + "%")

            if (dataCounter === al.page.list.length) {
                alLoadingHide();
                canadaUploader
                    (
                        dataList,
                        'album',
                        'jpeg',
                        function (response) {
                            al.cur.working = false;

                            // $("#input_12_1").val(al.form.pageCount);
                            // $("#input_12_2").val(al.selectedSizePrev);
                            // $("#input_12_3").val(response);
                            // $("#input_12_4").val(al.cur.totalPrice);

                            // $("#gform_submit_button_12").click();

                            var formData = new FormData();

                            formData.append("order_PageCount", al.form.pageCount);
                            formData.append("order_Size", al.selectedSizePrev);
                            formData.append("order_Urls", response);
                            
                            formData.append("price", al.cur.totalPrice);
                            formData.append("title","Photo Books");
                            formData.append("product_type","PhotoBooks");
                            formData.append("image_url",response.split('\n')[0].trim());
                            
                            $.ajax({
                                url: "https://canadaphotolab.com/wp-content/themes/printspace/shopify/create_draft_order.php",
                                method: "POST",
                                data: formData,
                                contentType: false,
                                processData: false,
                                dataType: "json",
                                success: function (response) {
                                    if (response.success) {
                                    window.location.href = response.url;
                                    } else {
                                    alert("Error: " + (response.message || "Something went wrong"));
                                    console.log(response);
                                    }
                                },
                                error: function (xhr, status, error) {
                                    alert("AJAX error: " + xhr.responseText + " " + status + " " + error);
                                    console.log(xhr.responseText);
                                },
                            });
                        }
                    );

                // for(let i = 0 ; i < dataList.length ; i++)
                // {
                //     $(".album").prepend("<img width='200' src='" + dataList[i] + "' >");
                // }

                return;
            }

            alExport(dataCounter, multiplier, function (result) {
                dataList.push(result);
                dataCounter++;
                addToList();
            });
        }
    }

    function alFormStepSelect(elm) {
        let step = $(elm).attr("id");
        al.form.ori = $(".albumFormStep1OptActive").attr("data-val");
        al.form.size = $(".albumFormStep2OptActive").attr("data-val");
        al.form.ratio = al.form.size.split("-");
        al.form.ratio = al.form.ratio[0] / al.form.ratio[1];
        al.selectedSizePrev = $(".albumFormStep2OptActive").attr("data-prev");

        if (step === "albumFormFormat") {
            $(".albumFormStep" + al.cur.formStep).hide();
            al.cur.formStep = 1;
            $(".albumFormStep" + al.cur.formStep).show();

            alFormProgressUpdate();
            alFormBackBtnUpdate();
        }
        else if (step === "albumFormSize") {
            $(".albumFormStep" + al.cur.formStep).hide();
            alFormStep2Show();
        }
        else if (step === "albumFormPrice") {
            $(".albumFormStep" + al.cur.formStep).hide();
            alFormStep3Show();
        }
    }

    function alExitConfirm() {
        if (al.cur.working)
            return "You have attempted to leave this page. Are you sure?";
        else
            return;
    }

    function alExport(pageNumber, scale, callBack = function (result) { }) {
        //create fabric
        let canvas = $("#albumExport").get(0);
        if ((al.default.fabricMaxWidth / 2) / al.form.ratio <= al.default.fabricMaxHeight) {
            canvas.width = al.default.fabricMaxWidth;
            canvas.height = (al.default.fabricMaxWidth / 2) / al.form.ratio;
        }
        else {
            canvas.width = (al.default.fabricMaxHeight * al.form.ratio) * 2;
            canvas.height = al.default.fabricMaxHeight;
        }

        canvas.width *= scale;
        canvas.height *= scale;

        al.fabric.exportCanvas = new fabric.Canvas('albumExport');
        al.fabric.exportCanvas.set({
            uniScaleTransform: false,
            enableRetinaScaling: true,
            uniScaleKey: "none",
            selection: false,
            containerClass: "albumAdjustImageArea",
            controlsAboveOverlay: true,
            backgroundColor: "#ffffff",
            perPixelTargetFind: false
        });
        al.fabric.exportCanvas.backgroundColor.repeat = 'repeat';
        al.fabric.exportCanvas.renderAll();

        //clean canvas
        for (let i = al.fabric.exportCanvas._objects.length - 1; i >= 0; i--) {
            al.fabric.exportCanvas.remove(al.fabric.exportCanvas._objects[i]);
        }

        //set page objects
        let fabricImages = al.page.list[pageNumber].images.slice();
        let pageObjects = al.page.list[pageNumber].objects.slice();
        let counter = 0;
        addObject();

        function addObject() {
            if (counter === pageObjects.length) {
                resume();
                return;
            }
            insertObject(pageObjects[counter], counter, function () {
                counter++;
                addObject();
            })
        }

        //insert object to canvas
        function insertObject(obj, objId, callback = function () { }) {
            if (obj.isType("rect")) {
                let clip = new fabric.Rect({
                    left: obj.left * scale,
                    top: obj.top * scale,
                    width: obj.width * scale,
                    height: obj.height * scale,
                    angle: obj.angle,
                    centeredRotation: true,
                    objectCaching: false,
                    cornerStyle: "circle",
                    cornerSize: 8,
                    borderColor: "#555555",
                    cornerColor: "#4cc2ce",
                    cornerStrokeColor: "#4cc2ce",
                });
                al.fabric.exportCanvas.add(clip);
                al.fabric.exportCanvas.renderAll();

                let clipId = al.fabric.exportCanvas._objects.length - 1;

                let imageSrc = al.image.list[fabricImages[clipId].id].src;

                fabric.Image.fromURL(imageSrc, function (img) {

                    let clipWidth = clip.width * al.page.list[pageNumber].state[objId].scale;
                    let clipHeight = clip.height * al.page.list[pageNumber].state[objId].scale;
                    let clipRatio = clipWidth / clipHeight;

                    let imgWidth = img.width;
                    let imgHeight = img.height;
                    let imgRatio = imgWidth / imgHeight;

                    if (img.height === 0) {
                        callback();
                        return;
                    }

                    let offsetX = 0;
                    let offsetY = 0;

                    let movedX = fabricImages[clipId].movedX * scale;
                    let movedY = fabricImages[clipId].movedY * scale;

                    let left = 0;
                    let top = 0;

                    if (imgRatio <= clipRatio) {
                        img.scaleToWidth(clipWidth);
                        offsetX = - (clipWidth - clip.width) / 2;
                        offsetY = - (((imgHeight * (clipWidth / imgWidth)) - clipHeight) / 2) - (clipHeight - clip.height) / 2;
                    }
                    else {
                        img.scaleToHeight(clipHeight);
                        offsetX = - (((imgWidth * (clipHeight / imgHeight)) - clipWidth) / 2) - (clipWidth - clip.width) / 2;
                        offsetY = - (clipHeight - clip.height) / 2;
                    }

                    left = offsetX + movedX;
                    if (left > 0)
                        left = 0;
                    else if ((- left) + clip.width > img.getScaledWidth())
                        left = clip.width - img.getScaledWidth();

                    top = offsetY + movedY;
                    if (top > 0)
                        top = 0;
                    else if ((- top) + clip.height > img.getScaledHeight())
                        top = clip.height - img.getScaledHeight();

                    let patternSourceCanvas = new fabric.StaticCanvas();
                    patternSourceCanvas.add(img);
                    patternSourceCanvas.setDimensions({
                        width: img.getScaledWidth(),
                        height: img.getScaledHeight(),
                    });

                    let filters = al.image.list[fabricImages[clipId].id].filters.slice();
                    if (filters.length > 0) {
                        fixfilters = [];
                        $.each(filters, function (i, item) {
                            if (item !== null && item !== undefined) {
                                fixfilters[i] = new fabric.Image.filters[item.type]({
                                    [item.type.toLowerCase()]: item[item.type.toLowerCase()]
                                });
                            }
                        });
                        patternSourceCanvas._objects[0].filters = fixfilters;
                        patternSourceCanvas._objects[0].applyFilters();
                    }

                    patternSourceCanvas.renderAll();

                    let pattern = new fabric.Pattern({
                        source: patternSourceCanvas.getElement(),
                        repeat: 'no-repeat',
                        offsetX: left,
                        offsetY: top
                    });

                    clip.set('fill', pattern);

                    patternSourceCanvas.renderAll();
                    al.fabric.exportCanvas.renderAll();

                    callback();
                });
            }
            else {
                obj.clone(function (clonedObj) {
                    clonedObj.left *= scale;
                    clonedObj.top *= scale;
                    clonedObj.width *= scale;
                    clonedObj.height *= scale;
                    clonedObj.fontSize *= scale;
                    al.fabric.exportCanvas.add(clonedObj);
                    al.fabric.exportCanvas.renderAll();

                    callback();
                })

            }
        }

        //set page background
        function resume() {
            let back = al.page.list[pageNumber].background;
            if (typeof (back) === "string") {
                al.fabric.exportCanvas.setBackgroundColor(back, function () {
                    al.fabric.exportCanvas.renderAll();
                    resume2();
                });
            }
            else {
                if (!isNaN(back))
                    back = al.back.list[back - 1];

                fabric.util.loadImage(back.src, function (img) {
                    let pattern = new fabric.Pattern({ source: img });
                    al.fabric.exportCanvas.setBackgroundColor(pattern, function () {
                        al.fabric.exportCanvas.renderAll();
                        resume2();
                    });
                });
            }
        }

        //resume to export
        function resume2() {
            callBack(
                changeDpiDataUrl(
                    al.fabric.exportCanvas.toDataURL({ format: 'jpeg' }),
                    al.default.dpi
                )
            );
        }

    }

    function alProjectSave(tempFile = null) {
        if (!al.cur.working && tempFile === null)
            return;

        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");

        let userId = $("#AlbumUserId").html();
        let name = "";
        let overwrite = 1;
        let saveTemp = 0;
        let data = "";

        //save temp file
        if (tempFile !== null) {
            if (userId === 0) {
                location.href = location.protocol + '//' + location.host + location.pathname;
                return;
            }

            $.getJSON(al.default.serverSidePath + "albumSaves/" + tempFile, function (response) {
                data = response;
                resume();
            });

            $.ajax({
                url: al.default.serverSidePath + "/deleteJson.php",
                method: "POST",
                data: {
                    name: tempFile,
                    temp: 1
                }
            })

            return;
        }

        if (userId == 0) {
            saveTemp = 1;
        }
        else {
            name = al.cur.projectName;
            if (name === "" || name === null) {
                name = prompt("Please enter name of your project : ", "Untitled Project");
                al.cur.projectName = name;
                overwrite = 0;
            }

            if (name === null) {
                alLoadingHide();
                return;
            }
        }

        //save images

        if (al.image.list.length > 0) {
            let imageCounter = 0;
            let imageId = [];
            let imageList = [];
            uploadImage();

            function uploadImage() {
                if (imageCounter > al.image.list.length - 1) {
                    if (imageList.length > 0)
                        resumeUpload();
                    else
                        resume();
                }
                else {
                    if (al.image.list[imageCounter].src.length < 300) {
                        imageCounter++;
                        uploadImage()
                    }
                    else {
                        imageId.push(imageCounter);
                        imageList.push(al.image.list[imageCounter].src);
                        imageList.push(al.image.list[imageCounter].thumbSrc);
                        imageCounter++;
                        uploadImage();
                    }
                }
            }

            function resumeUpload() {
                canadaUploader(
                    imageList,
                    "AlbumSave-shopify",
                    "jpeg",
                    function (response) {
                        response = response.split("\n");
                        for (let i = 0; i < imageId.length; i++) {
                            al.image.list[imageId[i]].src = response[(2 * i)];
                            al.image.list[imageId[i]].thumbSrc = response[(2 * i) + 1];
                        }

                        resume();
                    },
                    false
                )
            }
        }
        else {
            resume();
        }

        function resume() {
            if (tempFile === null) {
                data = Object.assign({}, al);
                delete data.default;
                delete data.layout;
                delete data.back;
                delete data.fabric;
                delete data.price;
                delete data.generate;
                deleteFills();
            }
            else {
                name = tempFile.replace(".json", "").split("-")[2];
                if (name === "") {
                    name = prompt("Please enter name of your project : ", "Untitled Project");
                    al.cur.projectName = name;
                    overwrite = 0;
                }

                if (name === null)
                    return;
            }

            saveJson();

            function saveJson() {
                $.ajax({
                    url: al.default.serverSidePath + "/saveJson.php",
                    method: "POST",
                    data: {
                        data: JSON.stringify(data),
                        userId: userId,
                        name: name,
                        overwrite: overwrite,
                        saveTemp: saveTemp
                    },
                    success: function (data) {
                        if (data === "duplicate") {
                            name = prompt("Your chosen name is duplicate.\nPlease select a new name : ", "Untitled Project");
                            saveJson();
                        }
                        else if (data === "new") {
                            name = prompt("Please enter name of your project : ", "Untitled Project");
                            saveJson();
                        }
                        else if (data.startsWith("temp")) {
                            al.cur.working = false;
                            $(".xoo-el-action-sc").attr("data-redirect", location.protocol + '//' + location.host + location.pathname + "?tempFile=" + data)
                            $(".xoo-el-action-sc")[0].click();
                            return;
                        }
                        else {
                            if (tempFile !== null) {
                                al.cur.working = false;
                                alert(data);
                                location.href = location.protocol + '//' + location.host + location.pathname + "?project=" + encodeURIComponent(name);
                            }
                            else {
                                al.cur.projectName = name;
                                alProjectNameSync();
                                $("#vancouverUploadCover").hide();
                                alLoadingHide();
                                al.cur.working = false;
                                alert(data);
                            }
                        }
                    },
                    error: function (data) {
                        $("#vancouverUploadCover").hide();
                        alert(data);
                    }
                })
            }

            function deleteFills() {
                let list = [];
                for (let i = 0; i < data.page.list.length; i++) {
                    for (let j = 0; j < data.page.list[i].objects.length; j++) {
                        if (data.page.list[i].objects[j].type === "rect") {
                            data.page.list[i].objects[j].fill = "";
                        }
                    }
                }

            }
        }
    }

    function alProjectOpenList(name) {
        let userId = $("#AlbumUserId").html();
        if (userId == 0) {
            $(".xoo-el-action-sc").attr("data-redirect", location.protocol + '//' + location.host + location.pathname + "?action=openList");
            $(".xoo-el-action-sc")[0].click();
            return;
        }

        $(".albumOpenList").html("");

        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");

        $.ajax({
            url: al.default.serverSidePath + "/openJson.php",
            method: "POST",
            data: {
                userId: userId
            },
            success: function (data) {
                alLoadingHide();

                if (data === "") {
                    alert("You do not have a saved project.");
                    alLoadingHide();
                }
                else {
                    data = data.split("\n");
                    for (let i = 0; i < data.length - 1; i++) {
                        data[i] = data[i].replace("albumSaves/", "");
                        data[i] = data[i].replace(".json", "");
                        data[i] = data[i].replace(userId + "-", "");
                        $(".albumOpenList").append(
                            "<div><div class='alOpenName'>" + data[i] + "</div><div class='alOpenDelete'>X</div></div>"
                        );
                    }

                    $(".albumOpen").show();
                }
            },
            error: function (data) {
                alLoadingHide();
                alert(data);
            }
        })
    }

    function alProjectOpen(elm) {
        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");
        al.cur.working = false;;
        location.href = location.protocol + '//' + location.host + location.pathname + "?project=" + encodeURIComponent($(elm).get(0).innerText);
    }

    function alProjectRestore(name) {
        let userId = $("#AlbumUserId").html();
        if (userId == 0) {
            $(".xoo-el-action-sc")[0].click();
            return;
        }

        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");

        $.getJSON(al.default.serverSidePath + "albumSaves/" + userId + "-" + name + ".json", function (data) {

            // let links = "";
            // $.each(data.image.list, function (i, item) {
            //     links += ' \n' + item.src;
            //     links += ' \n' + item.thumbSrc;
            // });
            // console.log(links);

            al.cur = data.cur;
            al.form = data.form;
            al.image = data.image;
            al.page = data.page;
            al.selectedSizePrev = data.selectedSizePrev;

            //show work area
            $(".albumForm").hide();
            $(".albumWorkArea").show();
            $("#albumWorkShop").addClass("albumHeaderProgressItemActive");
            al.cur.working = true;

            //objects Refine
            let list = [];
            for (let i = 0; i < al.page.list.length; i++) {
                for (let j = 0; j < al.page.list[i].objects.length; j++) {
                    let savedObj = al.page.list[i].objects[j];
                    let obj = "";
                    if (savedObj.angle > 0) {
                        console.log(savedObj);
                    }
                    if (savedObj.type === "rect") {
                        obj = new fabric.Rect({
                            left: savedObj.left,
                            top: savedObj.top,
                            width: savedObj.width,
                            height: savedObj.height,
                            angle: savedObj.angle,
                            centeredRotation: true,
                            objectCaching: false,
                            cornerStyle: "circle",
                            cornerSize: 8,
                            borderColor: "#555555",
                            cornerColor: "#4cc2ce",
                            cornerStrokeColor: "#4cc2ce"
                        });
                    }
                    else if (savedObj.type === "textbox") {
                        obj = new fabric.Textbox(savedObj.text, {
                            left: savedObj.left,
                            top: savedObj.top,
                            angle: savedObj.angle,
                            centeredRotation: true,
                            objectCaching: false,
                            cornerStyle: "circle",
                            cornerSize: 8,
                            borderColor: "#555555",
                            cornerColor: "#4cc2ce",
                            cornerStrokeColor: "#4cc2ce",
                            fill: savedObj.fill,
                            fontFamily: savedObj.fontFamily,
                            width: savedObj.width,
                            height: savedObj.height,
                            scaleX: savedObj.scaleX,
                            scaleY: savedObj.scaleY
                        });
                    }
                    al.page.list[i].objects[j] = obj;
                }
            }

            //setup work area
            alFabricCreate();
            alLayoutGetData(function () {
                alFinishShow();
                alImageListUpdate();
                alPageChange(al.cur.page, function () {
                    $(".albumCanvas").show();
                    $(".albumDropBox").hide();

                    $(".albumHeaderPreview").show();
                    alProjectNameSync();
                    al.cur.working = false;
                    alLoadingHide();
                }, false, true);
            });
        });
    }

    function alProjectDelete(elm) {
        if (!confirm("Are you sure you want to delete this project?"))
            return;

        let userId = $("#AlbumUserId").html();
        if (userId == 0) {
            $(".xoo-el-action-sc")[0].click();
            return;
        }

        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");

        $.ajax({
            url: al.default.serverSidePath + "/deleteJson.php",
            method: "POST",
            data: {
                userId: userId,
                name: $(elm).parent().find(".alOpenName").html(),
                temp: 0
            },
            success: function (data) {
                alLoadingHide();
                if (data) {
                    alProjectOpenList();
                }
                else {
                    alert(data);
                }
            },
            error: function (data) {
                alLoadingHide();
                alert(data);
            }
        })

    }

    function alProjectNameSync() {
        if (al.cur.projectName === "")
            $(".albumProjectName").hide();
        else {
            $(".albumProjectName").html("Project Name : " + al.cur.projectName);
            $(".albumProjectName").show();
        }

    }
    //Actions

    window.onbeforeunload = alExitConfirm;

    $(".generatePopUpList").on("click",">img",function(){
        alGenerateLayoutFin($(this));
    })

    $(".generatePopUpClose").click(function(){
        alGenerateLayoutPopUpClose();
    })

    $("#albumDesingTextOptionColor").on("input", function () {
        alTextOptColor();
    });

    $("#albumDesingTextOptionFont").on("change", function () {
        alTextOptFont();
    });

    $(".albumOpenList").on("click", ">div>.alOpenDelete", function () {
        alProjectDelete(this);
    })

    $(".albumOpenList").on("click", ">div>.alOpenName", function () {
        alProjectOpen(this);
    })

    $(".albumHeaderOpenBtn").click(function () {
        alProjectOpenList();
    });

    $(".albumOpenExitBtn").click(function () {
        $(".albumOpen").hide();
    });

    $(".albumHeaderSaveBtn").click(function () {
        alProjectSave();
    });

    $(".albumFormStep1Opts").on("click", ">div", function () {
        alFormStep1ChangeOpt(this);
    });

    $(".albumFormStep1Btn").click(function () {
        alFormStep1Btn();
    });

    $(".albumFormStep2Opts").on("click", ">div", function () {
        alFormStep2ChangeOpt(this);
    });

    $(".albumFormStep2Btn").click(function () {
        alFormStep2Btn();
    });

    $(".albumFormHeaderBackBtn").click(function () {
        alFormBackBtnClick();
    });

    $(".albumFormStep3Opts").on("click", ">div", function () {
        alFormStep3ChangeOpt(this);
    });

    $(".albumFormStep3Btn").click(function () {
        alFormStep3Btn();
    });

    $(".albumFormHeaderProgress").on("click", ">div", function () {
        alFormStepSelect(this);
    });

    $(".albumFooterImagesDropCon,.albumFooterOptUploadBtn , .albumDropBoxCon").click(function () {
        $("#albumFooterImagesDropFile").get(0).click();
    });

    $("#albumFooterImagesDropFile").change(function (e) {
        alFileAdd(e.target.files);
    });

    $("#albumFooterOptFilter").change(function () {
        alImageListUpdate();
    });

    $("#albumFooterOptImageCat").change(function () {
        alImageListUpdate();
    });

    $(".albumFooterOptZoomSlider").on("input", function () {
        alImageListResize();
    })

    $(".albumFooterOptGenerateBtn").click(function () {
        alGenerateLayout();
    });

    $(".albumCanvasPageNext,#ablumNextPrev").click(function () {
        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");
        alPageChange("next", function () {
            alLoadingHide();
        }, null, true);
    });

    $(".albumCanvasPagePrev,#ablumBackPrev").click(function () {
        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");
        alPageChange("prev", function () {
            alLoadingHide();
        }, null, true);
    });

    $(".albumCanvasHeaderLayoutBtn").click(function () {
        $(".albumLayoutList").toggle();
    });

    $(".albumLayoutList").on("click", ">img", function () {
        alLayoutChange(this);
    });

    $(".albumCanvasHeaderLayoutLeft").click(function () {
        alLayoutChange("", "prev");
    });

    $(".albumCanvasHeaderLayoutRight").click(function () {
        alLayoutChange("", "next");
    });

    $("#albumFooterOptBack").on("input", function () {
        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");
        alBackgroundChange("color", $(this).val(), function () {
            alLoadingHide();
        });
    });

    $(".albumFooterBackList").on("click", ">div", function () {
        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");
        alBackgroundChange("image", parseInt($(this).attr("id")), function () {
            alLoadingHide();
        });
    });

    $(".albumFooterOptImg").click(function () {
        alBackgroundToggleList();
    });

    $(".albumFooterOptBack").click(function () {
        $("#albumFooterOptBack").click();
    });

    $('html').keyup(function (e) {
        if (e.keyCode === 46) {
            let object = al.fabric.mainCanvas.getActiveObject();
            if (object !== undefined && object !== null) {
                if (object.isType("rect"))
                    alFabricRemove(al.fabric.mainCanvas._objects.indexOf(object));
                else
                    al.fabric.mainCanvas.remove(object);
            }

        }
        else if (e.keyCode === 69) {
            alExport(al.cur.page, 10, function (result) {
                canadaUploader(
                    [result],
                    'album',
                    'jpeg',
                    function (response) {
                        // console.log(response);
                        $("#vancouverUploadCover").hide();
                    }
                )
            });
        }
    });

    $(".albumCanvasHeaderAddSpread").click(function () {
        alPageAdd();
    });

    $(".albumExtraBtn").click(function () {
        if (confirm("Purchase another spread?")) {
            al.form.pageCount = parseInt(al.form.pageCount) + 1;
            al.cur.totalPrice = parseInt(al.cur.totalPrice) + 10;
            alFinishShow();
            alPageAdd();
        }
    });

    $(".albumHeaderPreview").click(function () {
        alPreviewShow();
    });

    $(".albumPreviewList").on("click", ">img", function () {
        alPreviewShowSingle(this);
    });

    $(".albumPreviewMakeChange").click(function () {
        alPreviewMakeChange();
    });

    $(".albumCanvasHeaderDesignBtn").click(function () {
        $(".albumCanvasHeader").hide();
        $(".albumDesign").show();
    });

    $(".albumDesignClose").click(function () {
        $(".albumCanvasHeader").show();
        $(".albumDesign").hide();
    });

    // $(".albumDesignZoom").click(function () {
    //     alDesignZoomBtn();
    // });

    $(".albumDesignZoomInputSlider").on("input", function () {
        alDesignZoomChange();
    });

    $(".albumDesignAdjust").click(function () {
        alDesignAdjustBtn();
    });

    $(".albumAdjustRanges").on("input", "input[type=range]", function () {
        alAdjustRangeChange($(this));
    });

    $(".albumAdjustRanges").on("click", " .albumAdjustRangeReset", function () {
        let elm = $(this).parents(".albumAdjustRange").find("input[type=range]");
        elm.val(0);
        alAdjustRangeChange(elm);
    });

    $(".albumAdjustReset").click(function () {
        alAdjustReset(true);
    });

    $(".albumAdjustSave").click(function () {
        alAdjustSave();
    });

    $(".albumAdjustClose").click(function () {
        $(".albumDesignAdjust").click();
    });

    $(".albumDesignText").click(function () {
        alTextBtn();
    });

    $(".albumFooterImagesList").on("click", ">div", function () {
        alImageListClick(this);
    });

    $(".albumHeaderCancel").click(function () {
        if ($(".albumForm").is(":visible"))
            return;
        alLoadingShow("Processing...<br> Please wait . It take a few minutes.");
        location.href = location.protocol + '//' + location.host + location.pathname;
    });

    $(".albumHeaderFinishBtn").click(function () {
        alFinishBtn();
    });

    // drag and drop

    $(".albumCanvasCon").droppable({
        over: function (event, ui) {
        },
        out: function (event, ui) {
        },
        drop: function (event, ui) {
            let curX = event.pageX - $("#albumMainCanvas").offset().left;
            let curY = event.pageY - $("#albumMainCanvas").offset().top;
            let imageWapper = ui.draggable[0];

            if ($(imageWapper).attr("id") === "albumMoveIcon")
                return;

            alFabricDrop(imageWapper, "", curX, curY);
        }
    });

    $(".albumDropBox").droppable({
        over: function (event, ui) {
        },
        out: function (event, ui) {
        },
        drop: function (event, ui) {
            let curX = event.pageX - $("#albumMainCanvas").offset().left;
            let curY = event.pageY - $("#albumMainCanvas").offset().top;
            let imageWapper = ui.draggable[0];
            alFabricDrop(imageWapper, "", curX, curY);
        }
    });

    $('.albumFooterImagesDropCon,.albumFooterImagesList,.albumDropBoxCon').droppable();
    $('.albumFooterImagesDropCon,.albumFooterImagesList,.albumDropBoxCon').on('dragover', function (e) {
        e.preventDefault();
        e.stopPropagation();
        alFileDragOver();
    });
    $('.albumFooterImagesDropCon,.albumFooterImagesList,.albumDropBoxCon').on('dragenter', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });
    $('.albumFooterImagesDropCon,.albumFooterImagesList,.albumDropBoxCon').on('dragleave', function (e) {
        e.preventDefault();
        e.stopPropagation();
        alFileDragLeave();
    });
    $('.albumFooterImagesDropCon,.albumFooterImagesList,.albumDropBoxCon').on('drop', function (e) {
        $(this).removeClass("frameMyUploadAreaDrag");
        if (e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files.length) {
            e.preventDefault();
            e.stopPropagation();
            alFileAdd(e.originalEvent.dataTransfer.files);
        }
    });



});